const ar = {
	translation: {
		TITLE: {
			HP: 'حفظ',
			LOGIN: 'تسجيل الدخول',
			RESET_PASSWORD: 'إعادة تعيين كلمة المرور',
			REGISTER: 'تسجيل',
			DASHBOARD: 'لوحة المعلومات',
			ACTIONS: 'العمليات',
			COMPANY_DOCUMENTS: 'تحديث مستندات الشركة',
			SHAREHOLDERS_REGISTRY: 'سجل المساهمين',
			PROFILE: 'الملف الشخصي',
			USERS_MANAGEMENT: 'إدارة المستخدمين',
			COMPANY_INFORMATION: 'معلومات الشركة',
			WALLET: 'المحفظة',
			NOT_AUTHORIZED: 'غير مصرح',
			NOT_FOUND: 'غير موجود',
			ASSEMBLIES: 'الجمعيات',
			MORTGAGE: 'الرهن',
			CAP_TABLE: 'جدول الملكية',
			MORTGAGES: 'الرهن',
			CREATE_MORTGAGE: 'إنشاء رهن',
			MORTGAGE_DETAILS: 'تفاصيل الرهن',
			PAYMENT_SUCCESS: 'نجح الدفع',
			PAYMENT_FAILED: 'فشل الدفع',
			UNAUTHORIZED: 'غير مصرح',
			TRANSACTIONS_LOGS: 'سجل التناقل',
			PAYMENT_CHECK: 'التحقق من الدفع',
			VOTING: 'تصويت',
		},
		PAGES: {
			DASHBOARD: 'لوحة المعلومات',
			COMPANY_DOCUMENTS: 'مستندات الشركة',
			SHAREHOLDERS_REGISTRY: 'سجل المساهمين',
			PROFILE: 'الملف الشخصي',
			ACTIONS: 'العمليات',
			USERS_MANAGEMENT: 'إدارة المستخدمين',
			COMPANY_INFORMATION: 'معلومات الشركة',
			WALLET: 'المحفظة',
			SHAREHOLDER_INFO: 'معلومات مساهم',
			REGISTRY_TRANSACTIONS: 'قيد حركة سهم',
			HEIRS_TRANSFER: 'قيد حركة ورثة',
			SUSPEND: 'تعليق',
			NOTICE: 'تبليغ',
			ANNOUNCEMENT: 'الإعلانات',
			UPDATE_DOCUMENTS: 'تحديث المستندات',
			FINANCIAL_STATEMENT: 'القوائم المالية',
			OVERVIEW: 'نظرة عامة',
			SHAREHOLDERS_LIST: 'سجل المساهمين',
			MAJOR_SHAREHOLDERS: 'كبار الملاك',
			TRANSACTIONS_LOGS: 'سجل التناقل',
			PAYMENTS: 'الفوترة',
			DATA_ROOM: 'غرفة البيانات',
			ASSEMBLIES: 'الجمعيات',
			ASSEMBLY_ATTENDANCE: 'حضور الجمعية',
			CAP_TABLE: 'جدول الملكية',
			MORTGAGES: 'الرهن',
			BRAND_IDENTITY: 'الهوية البصرية',
			BOARDS: 'مجلس الإدارة',
			BOARD_MEETING: 'اجتماع مجلس الإدارة',
			COMMITTEES: 'اللجان',
			MEETING_ATTENDANCE: 'حضور الاجتماع',
			MEETING_DECISION_COMMENTS: 'تعليقات قرار الاجتماع',
			COMMENTS_ADDED_SUCCESS: 'تمت إضافة التعليقات بنجاح',
			CAPITALS: 'رأس المال',
			DIVIDENDS: 'توزيع الأرباح',
			COMMITTEE_MEETING: 'اجتماعات اللجان',
			LOYALTY_PROGRAMS: 'برنامج الولاء',
		},
		COMMON: {
			EMAIL: 'البريد الإلكتروني',
			EMAIL_REQUIRED: 'البريد الإلكتروني مطلوب',
			PASSWORD: 'كلمة المرور',
			PASSWORD_REQUIRED: 'كلمة المرور مطلوبة',
			PASSWORD_CONFIRMATION: 'تأكيد كلمة المرور',
			PASSWORD_CONFIRMATION_REQUIRED: 'تأكيد كلمة المرور مطلوبة',
			PASSWORDS_NOT_MATCH: 'كلمة المرور وتأكيد كلمة المرور لا يتطابقا',
			PASSWORD_MIN_8: 'كلمة المرور لا يمكن ان تقل عن 8 حروف',
			DELETE: 'حذف',
			CONFIRM: 'تأكيد',
			VIEW: 'عرض',
			CHANGE: 'تغيير',
			DISCARD: 'الغاء',
			BACK: 'العودة',
			UPLOAD: 'رفع',
			ADD: 'إضافة',
			SUCCESS: 'مكتملة',
			ERROR: 'حدث خطأ',
			OPS: 'اوبس',
			FETCH_ERROR: 'حدث خطأ أثناء استرجاع البيانات.',
			SUBMIT_ERROR: 'حدث خطأ أثناء إرسال البيانات.',
			ACTIONS: 'الإجراءات',
			CREATE: 'إنشاء',
			UPDATE: 'تحديث',
			PHONE_INVALID: 'رقم الجوال غير صحيح',
			PHONE_NUMBER: 'رقم الجوال',
			PHONE_REQUIRED: 'رقم الجوال مطلوب',
			SAR: 'ر.س',
			EDIT: 'تعديل',
			SEARCH: 'بحث',
			ID: 'الرقم التعريفي',
			DOWNLOAD: 'تحميل',
			CANCEL: 'الغاء',
			N_A: 'لا يوجد',
			NO_DATA: 'لا توجد بيانات',
			STATUS: 'الحالة',
			ONLY_PNG_JPG: 'يدعم فقط ملفات بصيغة PNG و JPG.',
			ONLY_PDF: 'يدعم فقط ملفات بصيغة PDF.',
			ACTIVE: 'نشط',
			INACTIVE: 'غير نشط',
			POWERED_BY: 'مشغل بواسطة',
			TAKHAROJ_FINANCE: 'تخارج المالية©',
			HEFTH_PLATFORM: 'منصة حفظ',
			NEXT: 'التالي',
			NAME: 'الاسم',
			MAX: 'الحد الأقصى',
			GB: 'غيغابايت',
			MB: 'ميغابايت',
			KB: 'كيلوبايت',
			B: 'بايت',
			REUPLOAD: 'اعادة رفع',
			LOGOUT: 'تسجيل الخروج',
			NOTE: 'ملاحظة',
			SELECT_DATE: 'اختر تاريخاَ',
			WALLET: 'المحفظة',
			PLAN: 'الباقة',
			POINTS: 'نقطة',
			POINT: 'نقطة',
			SUBMIT: 'إرسال',
			CURRENT_PASSWORD: 'كلمة المرور الحالية',
			SHAREHOLDER: 'مساهم',
			NATIONAL_ID: 'الهوية الوطنية',
			FOUNDER: 'مؤسس',
			EXECUTIVE: 'تنفيذي',
			BOARD_OF_DIRECTOR: 'مجلس الإدارة',
			FULLY_PAID: 'مدفوعة بالكامل',
			COMMON: 'عادية',
			COMMON_SHARES: 'الأسهم العادية',
			PREFERRED: 'ممتازة',
			PREFERRED_SHARES: 'الأسهم الممتازة',
			FREE: 'الحرة',
			FREE_PRICE: 'مجاني',
			SUSPENDED: 'المعلقة',
			MORTGAGED: 'المرهونة',
			ACKNOWLEDGE: 'أنا أقر وأقبل الشروط والأحكام, سياسة الخصوصية, إخلاء المسؤولية و سياسة الاسترداد لاستخدام هذا الموقع.',
			SHAREHOLDER_FULL_NAME: 'اسم المساهم',
			SHARES: 'سهم',
			FREE_SHARES: 'الاسهم الحرة',
			SUSPENDED_SHARES: 'الاسهم المعلقة',
			MORTGAGED_SHARES: 'الاسهم المرهونة',
			NUM_OF_SHARES: 'عدد الأسهم',
			YES: 'نعم',
			NO: 'لا',
			SAVE: 'حفظ',
			WELCOME: 'أهلاً',
			ACTIVATE: 'تفعيل',
			SEND: 'إرسال',
			AMOUNT: 'المبلغ',
			CREATED_AT: 'تاريخ الإنشاء',
			PENDING: 'قيد الانتظار',
			COMPLETED: 'مكتمل',
			FAILED: 'فشل',
			NOTIFICATIONS: 'الإشعارات',
			MARK_ALL_AS_READ: 'تحديد الكل كمقروء',
			GENERATE: 'إنشاء',
			TOTAL: 'الإجمالي',
			CHECK: 'تحقق',
			SHAREHOLDERS: 'المساهمين',
			TREASURY_SHARES: 'أسهم الخزينة',
			EXPORT_TO_EXCEL: 'تصدير البيانات إلى إكسيل',
			ALL: 'الكل',
			REJECTED: 'مرفوض',
			CANCELED: 'ملغي',
			EXPIRED: 'منتهي',
			START_DATE: 'من تاريخ',
			END_DATE: 'إلى تاريخ',
			SHARE_PRICE: 'سعر السهم',
			TRANSACTION_TYPE: 'نوع المعاملة',
			TRANSACTIONS: 'المعاملات',
			UPDATED_AT: 'وقت التحديث',
			EQUITY: 'نسبة الملكية',
			DATE_RANGE: 'في الفترة',
			RESET: 'إعادة تعيين',
			TOTAL_COMMON: 'إجمالي العادية',
			TOTAL_PREFERRED: 'إجمالي الممتازة',
			DATE_OF_BIRTH: 'تاريخ الميلاد',
			REMAINING_TRANSACTION: 'المتبقي: {{num}} معاملة',
			'UNDER-REVIEW': 'قيد المراجعة',
			COUNTRY: 'البلد',
			AVAILABLE: 'متوفر',
			DESCRIPTION: 'الوصف',
			TAB_TO_UPLOAD: 'انقر لرفع الملف',
			UPLOAD_SUCCESSFUL: 'تم رفع الملف بنجاح',
			SENT: 'تم الارسال',
			APPROVED: 'معتمد',
			TYPE: 'النوع',
			PUBLISHED: 'منشور',
			SCHEDULED: 'مجدول',
			COPY: 'نسخ',
			ADDRESS: 'العنوان',
			EMAIL_ADDRESS: 'البريد الإلكتروني',
			FULL_NAME: 'الاسم الكامل',
			NATIONAL_ID_LENGTH: 'الهوية الوطنية يجب أن يتكون من 10 أرقام',
			FIELD_REQUIRED: 'هذا الحقل مطلوب',
			NUMBER_OF_SHARES_GREATER_THAN_ZERO: 'يجب أن يكون عدد الأسهم أكبر من صفر',
			ATTENTION: 'تنبيه',
			FIELD_LENGTH_VALIDATION: 'هذا الحقل يجب أن يتكون من 12 حرفًا على الأقل.',
			ARABIC_ONLY: ' يرجى إدخال النص باستخدام الأحرف العربية فقط',
			ENGLISH_ONLY: 'يرجى إدخال النص باستخدام الأحرف الإنجليزية فقط',
			MIN_VALUE_0: 'يجب أن يكون هذا الحقل أكبر من أو يساوي 0',
			EMAIL_INVALID: 'يرجى إدخال عنوان بريد إلكتروني صالح',
			BLOCKED: 'محظور',
			DELETED: 'محذوف',
			RECAPTCHA_REQUIRED: 'يرجى إكمال التحقق من reCAPTCHA للمتابعة',
			RECORDS: 'سجل',
			DOWNLOAD_ERROR: 'حدث خطأ أثناء تحميل الملف. يرجى المحاولة مرة أخرى لاحقًا.',
			OTHER: 'الأخريين',
			REVERSED: 'مردود',
			SHARES_TYPE: 'نوع الأسهم',
			FREE_PLAN: 'الأساسية',
			CLICK_TO_UPLOAD: 'اضغط لرفع الملف',
			UPLOAD_SUCCESSFULLY: 'تم رفع الملف بنجاح',
			CANT_USED_MULTIPLE: 'لا يمكن استخدام هذا الحقل عدة مرات',
			GENERATED: 'فعال',
			ARABIC_DESC: 'الوصف بالعربية',
			ENGLISH_DESC: 'الوصف بالإنجليزية',
			UNDERREVIEW: 'تحت المراجعة',
			ONGOING: 'منعقدة',
			PREVIEW: 'عرض',
			NAME_AR: 'الاسم باللغة العربية',
			NAME_EN: 'الاسم باللغة الإنجليزية',
			CANNOT_ACCESS_SERVICE: 'لا يمكنك الوصول إلى هذه الخدمة',
			SEARCHING: 'جارٍ البحث',
			NO_DATA_FOUND: 'لا توجد بيانات',
			PAYMENT_SUCCESS: 'تم الدفع بنجاح',
			THANK_YOU: 'شكرا لك على الشراء!',
			PAYMENT_FAILED: 'فشل عملية الدفع',
			PAYMENT_FAILED_DESC: 'يرجى التحقق من تفاصيل بطاقتك والمحاولة مرة أخرى',
			REDIRECTING: 'سيتم إعادة توجيهك خلال {{seconds}} ثوانٍ',
			BACK_TO_DASHBOARD: 'العودة إلى لوحة المعلومات',
			REFERENCE_NUMBER: 'الرقم المرجعي',
			TOTAL_COMMON_SHARES: 'الأسهم العادية',
			ONLY_XLSX: 'يدعم فقط تنسيق ملفات XLSX',
			WAITING_ACTIVATION: 'في انتظار التفعيل',
			AMENDMENTS: 'تعديلات',
			DOCUMENT_AMENDMENTS: 'تعديل مستند ',
			REGISTRY_AMENDMENTS: 'تعديل سجل المساهمين',
			UNDER_REVIEW: 'تحت  المراجعة',
			UPLOAD_REQUIREMENTS: 'رفع متطلبات ',
			DRAFT: 'مسودة',
			CLOSE: 'إغلاق',
			CONTINUE: 'متابعة',
			PAYMENT_ERROR_GATEWAY: 'حدث خطأ في بوابة الدفع.',
			TRY_AGAIN: 'يرجى المحاولة مرة أخرى لاحقًا.',
			NOT_FOUND_DESC: 'عذرًا، الصفحة التي زرتها غير موجودة',
			UNAUTHORIZED_DESC: 'عذرًا، ليس لديك إذن للوصول إلى هذه القسم اطلب من مسؤولك الحصول على الإذن.',
			CONFIRMATION: 'تأكيد',
			ALERT: 'تنبيه',
			CONTACT_ADMIN: 'يرجى الاتصال بمسؤول النظام للمساعدة.',
			REFRESH_PAGE: 'تحديث الصفحة',
			CHARGE: 'شحن',
			PENDINGPAYMENT: 'في انتظار الدفع',
			PROCESSING: 'جارٍ المعالجة',
			DISTRIBUTED: 'تم التوزيع',
			EXECUTE: 'تنفيذ',
			STANDING: 'قائم',
			TO_CHARGE: 'لإجراء عمليات شحن النقاط او ترقية الحساب التواصل مع مدير الحساب الخاص بكم',
			CHECKING_PAYMENT_STATUS: 'جار التحقق من حالة الدفع',
			PAYMENT_SUCCESSFULLY: 'تمت عملية الدفع بنجاح',
			CONTRACT: 'العقد',
			PAYMENT_CHECK: 'التحقق من الدفع',
			CHECKING_PAYMENT: 'جار التحقق من الدفع',
			PAYMENT_EXIST: 'معاملة صحيحة',
			PAYMENT_NOT_EXIST: 'معاملة غير صحيحة',
			BIRTH_DATE: 'تاريخ الميلاد',
			PRICE: 'السعر',
			TERMINATED: 'تم إنهاء اللجنة',
			WRITINGMINUTES: 'كتابة المحاضر',
			QUORUMNOTMET: 'لم يتم تحقيق النصاب',
			NOTHELD: 'لم يُعقد',
			COMPANY_GENERAL_SUSPENDED: 'تم تعليق الشركة بشكل عام',
			PENDINGAPPROVAL: 'في انتظار الموافقة',
			TANAQUL_APP: 'تطبيق تناقل',
			NO_NOTIFICATIONS: 'لا توجد إشعارات',
			COPY_PUBLIC_LINK: 'نسخ الرابط العام',
		},
		LOGIN: {
			TITLE: 'مرحبًا بك',
			SUBTITLE: 'أدخل البيانات الخاصة بك للوصول إلى حسابك',
			REMEMBER_ME: 'تذكرني',
			REMEMBER_ME_FOR_30: 'تذكرني لمدة 30 يومًا',
			FORGET_PASSWORD: 'نسيت كلمة المرور',
			LOGIN: 'تسجيل الدخول',
			DONT_HAVE_ACCOUNT: 'ليس لديك حساب؟',
			REGISTER_NOW: 'سجل الآن',
			INTRO_TITLE: 'أرفع مستويات حوكمة شركتك.',
			INTRO_SUBTITLE:
				'عالمياً تسعى الشركات بشكل مستمر ودؤوب للوصول الى الكمال في إدارة وحوكمة سجلات المساهمين مما ينعكس إيجابا على مركزها المالي. نحن في حفظ نعمل على ان تكون مهمتنا الأولى في دعم هذا التوجه من خلال أول منصة مؤتمتة بشكل كامل ونعدك بتجربة لا مثيل لها.',
			REGISTER_COMPANY_ACCOUNT: 'تسجيل حساب شركة',
			REGISTER_HEADER: 'التسجيل للشركات ذات الكيانات التالية:',
			REGISTER_POINT_1: 'مساهمة مغلقة',
			REGISTER_POINT_2: 'مساهمه مغلقة مبسطة',
			REGISTER_POINT_3: 'مساهمة مغلقة مختلطة',
			SHAREHOLDER_LOGIN: 'تسجيل ودخول المساهمين من خلال تطبيق تناقل',
			INVALID_CREDENTIALS: 'تعذر تسجيل الدخول. اسم المستخدم أو كلمة المرور غير مطابق لسجلاتنا',
			HOME: 'الصفحة الرئيسية',
		},
		RESET_PASSWORD: {
			HOME: 'الصفحة الرئيسية',
			ENTER_PHONE: 'فضلا ادخال رقم الجوال',
			SEND_OTP: 'ارسال رمز التأكيد',
			VERIFY_PHONE: 'التحقق من رقم الجوال',
			OTP: 'رمز التأكيد المؤقت',
			RESEND_OTP: 'إعادة ارسال رمز التأكيد',
			ENTER_PASSWORD: 'ادخل كلمة المرور الجديدة',
			PASSWORD_CHANGED: 'تم تغيير كلمة المرور بنجاح',
			REDIRECT_TO_HOME: 'سيتم إعادة توجيهك إلى الصفحة الرئيسية',
			REST_YOUR_PASSWORD: 'إعادة تعيين كلمة المرور',
			FILL_TO_RESET: 'املأ بياناتك لتتمكن من إعادة تعيين حسابك',
			RESET_PASSWORD: 'إعادة تعيين كلمة المرور',
			PHONE_NOT_REGISTERED: 'رقم الجوال غير مسجل لدينا',
		},
		REGISTER: {
			CONTACT_PERSON: 'معلومات الحساب والتواصل',
			SUBTITLE: 'معلومات ممثل الشركة و الإدارة التنفيذية',
			REPRESENTATIVE_NAME_AR: 'اسم الممثل باللغة العربية',
			REPRESENTATIVE_NAME_EN: 'اسم الممثل باللغة الإنجليزية',
			REPRESENTATIVE_EMAIL: 'البريد الإلكتروني للممثل	',
			REPRESENTATIVE_NATIONAL_ID: 'الهويه الوطنية / مقيم',
			REPRESENTATIVE_PHONE_NUMBER: 'رقم جوال الممثل',
			DO_YOU_HAVE_EMPLOYEE: 'هل لديك رمز موظف حفظ؟',
			HEFTH_EMPLOYEE_CODE: 'رمز موظف حفظ',
			PERSON_INF: 'معلومات ممثل الكيان التجاري (المستخدم الفعلي للنظام) ',
			AUTHORIZED_SIGNATORY_INF: 'معلومات المفوض بالتوقيع (رئيس مجلس الإدارة / الرئيس التنفيذي)',
			VERIFY_PHONE: 'التحقق من رقم الجوال',
			ENTER_OTP: 'لتأكيد رقمك فضلا ادخال الكود المرسل الى',
			RESEND_OTP: 'إعادة ارسال رمز التأكيد',
			OTP_RESENT: 'تم إعادة إرسال رمز التحقق',
			PHONE_CHANGED: 'تم تحديث رقم الجوال. يرجى التحقق من (OTP) لإتمام التأكيد.',
			CHANGE_PHONE_NUMBER: 'تغيير رقم الجوال',
			WRONG_NUMBER: 'استخدام رقم اخر؟',
			CHANGE_DESC: 'قم بتغيير رقم الجوال الخاص بك لاستكمال عملية التسجيل',
			CREATE_COMPANY_PROFILE: 'معلومات الكيان التجاري',
			FILL_COMPANY_DATA: 'فضلا ادخال جميع البيانات بشكل صحيح',
			COMPANY_INF: 'المعلومات الأساسية للكيان التجاري',
			COMPANY_AR_NAME: 'اسم الكيان التجاري بالعربية',
			COMPANY_EN_NAME: 'اسم الكيان التجاري بالإنجليزية',
			COMPANY_TYPE: 'نوع الكيان التجاري',
			SELECT_COMPANY_TYPE: 'اختر نوع الكيان التجاري',
			SELECT_COMPANY_TYPE_DESC: 'فضلا اختر نوع الكيان التجاري للمتابعة',
			COMPANY_SECTOR: 'قطاع الكيان التجاري',
			CAPITAL: 'رأس المال المصدر',
			AUTHORIZED_CAPITAL: 'رأس المال المعلن',
			AUTHORIZED_CAPITAL_VALIDATION: 'يجب أن يكون رأس المال المصرح به أكبر من أو يساوي رأس المال المصدر',
			PAR_VALUE: 'القيمة الاسمية للسهم',
			BOARD_MEMBER_NO: 'عدد اعضاء مجلس الادارة',
			COMMERCIAL_REGISTRATION_NUMBER: 'رقم السجل التجاري',
			COMMERCIAL_REGISTRATION_NUMBER_IF_EXISTS: 'رقم السجل التجاري (إن وجد)',
			UNIFIED_REGISTRATION_NUMBER: 'الرقم الوطني الموحد',
			VAT_REGISTRATION_NUMBER: 'رقم تسجيل ضريبه القيمه المضافه',
			COMPANY_ADDRESS: 'عنوان الكيان التجاري',
			COMPANY_LOGO: 'شعار الكيان التجاري',
			COMPANY_STAMP: 'ختم الكيان التجاري',
			CHOOSE_PLAN: 'فضلا اختيار الباقه',
			START_NOW: 'ابدأ الأن',
			FREE: 'مجاناً',
			PAID_FEATURES: 'الميزات المدفوعة',
			ANNUALLY: 'سنويًا',
			UNLIMITED: 'غير محدود',
			SUBSCRIBE: 'اشتراك',
			SUBSCRIBE_PAYMENT: 'الدفع والاشتراك',
			SUBSCRIBE_INITIATING_DATE: 'بدء الاشتراك',
			SUBSCRIBE_INITIATING_DATE_DESC: 'سيحدد هذا بداية تاريخ انفاذ العقد.',
			CHOOSE_INITIATE_DATE: 'اختر تاريخ انفاذ العقد',
			SUBSCRIPTION_NOTE:
				'لن تتمكن من تنفيذ اي عمليات على حسابك حتى تاريخ بدء انفاذ الاتفاقية بغض النظر عن الدفع من عدمه. علما بان لن يتم تنشيط باقة الاعمال حتى يتم سداد رسوم الباقة. هذا التقييد يشمل جميع الخدمات المقدمة للشركة او مساهميها من خلال التطبيقات المرتبطة في حفظ باي شكل من الاشكال. فضلا التاكد من التاريخ قبل انشاء العقد.',
			THANKS_FOR_SUBSCRIPTION: 'شكرا لاشتراكك',
			PLEASE_DOWNLOAD: 'فضلا تحميل العقد وتوقيعه وتصديقه من الغرفه التجاريه',
			HEFTH_SERVICES_AGREEMENTS: 'إتفاقية إستخدام خدمات حفظ',
			DOWNLOAD_FIRST: 'من فضلك حمل إتفاقية إستخدام خدمات حفظ اولاً',
			COMMERCIAL_REGISTRATION_NUMBER_LEN: 'رقم السجل التجاري يجب أن يتكون من 10 أرقام',
			UNIFIED_REGISTRATION_NUMBER_LEN: 'الرقم الموحد يجب أن يتكون من 10 أرقام',
			VAT_REGISTRATION_NUMBER_LEN: 'رقم تسجيل ضريبه القيمه المضافه يجب أن يتكون من 15 أرقام',
			PAID: 'مدفوع',
			INVALID_OTP: 'رمز التحقق غير صحيح',
			THREE_WORDS_VALIDATION: 'الاسم يجب أن يحتوي على ثلاث كلمات على الأقل',
			PAR_VALUE_VALIDATION: 'يجب أن تكون القيمة الاسمية 0.5 أو رقمًا صحيحًا',
			BOARD_MEMBER_NO_MIN: 'عدد أعضاء مجلس الإدارة يجب أن يكون 3 على الأقل',
			BOARD_MEMBER_NO_MAX: 'عدد أعضاء مجلس الإدارة يجب أن يكون 11 على الأكثر',
			BOARD_MEMBER_NO_INTEGER: 'عدد أعضاء مجلس الإدارة يجب أن يكون عدد صحيح',
			NATIONAL_ADDRESS: 'العنوان الوطني',
			VERIFY_NOT_REBOT: 'التحقق من أنك لست روبوتًا',
			COMPANY_MANAGER: 'معلومات الرئيس التنفيذي للكيان التجاري',
			CAPITAL_INFORMATION: 'معلومات رأس المال',
		},
		SIDEBAR: {
			MAIN_MENU: 'القائمة الرئيسية',
			ACCOUNT_INFORMATION: 'معلومات الحساب',
			DASHBOARD: 'لوحة المعلومات',
			USER_PROFILE: 'الملف الشخصي',
			ADD_COMPANY_DOCUMENTS: 'رفع مستندات الشركة',
			VIEW_COMPANY_DOCUMENTS: 'عرض مستندات الشركة',
			UPDATE_COMPANY_DOCUMENTS: 'تحديث مستندات الشركة',
			SHAREHOLDERS_REGISTRY: 'سجل المساهمين',
			ADD_SHAREHOLDERS_REGISTRY: 'ادخال سجل المساهمين',
			VIEW_SHAREHOLDERS_REGISTRY: 'عرض سجل المساهمين',
			UPDATE_SHAREHOLDERS_REGISTRY: 'تحديث سجل المساهمين',
			ACTIONS: 'العمليات',
			USERS_MANAGEMENT: 'إدارة المستخدمين',
			COMPANY_INFORMATION: 'معلومات الشركة',
			MORTGAGE_REQUEST: 'طلب رهن',
			MORTGAGE_LIST: 'قائمة الرهن',
			PERSONAL_INFORMATION: 'معلومات شخصية',
			PROFILE: 'الملف الشخصي',
			SHAREHOLDERS_LIST: 'سجل المساهمين',
			CAP_TABLE: 'جدول الملكية',
			TRANSACTIONS_LOGS: 'سجل التناقل',
		},
		DOCUMENTS: {
			UPLOAD_DOCUMENTS: 'تحميل مستندات الشركة',
			DOCUMENTS_REVIEW: 'مراجعة مستندات الشركة',
			SUBSCRIPTION_CONTRACT: 'اتفاقيه الاشتراك فى حفظ',
			PLEASE_UPLOAD: 'فضلا رفع المستندات التالية',
			PLEASE_UPLOAD_DESC: 'لإكمال التسجيل، فضلا رفع المستندات المطلوبة',
			COMPANY_ESTABLISHMENT: 'عقد تأسيس الشركة (آخر نسخة)',
			VAT_REGISTRATION: 'شهادة التسجيل في ضريبة القيمة المضافة',
			BOARD_OF_DIRECTORS: 'مجلس الإدارة',
			COMMERCIAL_REGISTRATION: 'السجل التجاري',
			COMMERCIAL_REGISTRATION_IF_EXISTS: 'السجل التجاري (إن وجد)',
			APPROVED_AUTHORIZATION: 'تفويض مصدق للمستخدم الفعلى',
			BOARD_COMMITMENT: 'قرارات تشكيل لجان المجلس (ان وجد)',
			CHAIRMAN_SIGNATURE: 'توقيع رئيس مجلس الإدارة',
			CHAIRMAN_NAME_AR: 'إسم رئيس مجلس الإدارة بالعربية*',
			CHAIRMAN_NAME_EN: 'إسم رئيس مجلس الإدارة الإنجليزية',
			AVERAGE_CURRENT_VALUE: 'متوسط القيمة الحالية للسهم',
			CERTIFIED_COMPANY_VALUATION: 'تقييم معتمد للشركة وقيمة السهم(إن وجد)',
			USER_ASSIGNMENT_FORM: 'نموذج تفويض مستخدم',
			AUTHORIZED_SIGNATORY_PERSON: 'معلومات المفوض بالتوقيع',
			AUTHORIZED_SIGNATORY_PERSON_NAME: 'اسم المفوض بالتوقيع',
			AUTHORIZED_SIGNATORY_PERSON_DESC: 'تغيير اسم المفوض بالتوقيع في عقد اتفاقية استخدام المنصة',
			AUTHORIZED_SIGNATORY_NAME_UPDATED: 'تم تحديث اسم المفوض بالتوقيع بنجاح',
		},
		PROFILE: {
			PROFILE: 'الملف الشخصي',
			CHANGE_PASSWORD: 'تغيير كلمة المرور',
			USER_PROFILE_INF: 'معلومات الملف الشخصي للمستخدم',
			UPDATE_YOUR_PROFILE: 'تحديث ملفك الشخصي',
			UPDATE_YOUR_PERSONAL_DETAILS: 'تحديث بياناتك الشخصية',
			SYSTEM_ADMIN_INF: 'معلومات مدير النظام',
			ORGANIZATION_NAME: 'اسم المؤسسة',
			ORGANIZATION_ID: 'رقم المؤسسة',
			SYSTEM_ADMIN_EMAIL: 'البريد الإلكتروني لمدير النظام',
			SYSTEM_ADMIN_ID: 'رقم هوية مدير النظام',
			PASSWORD_CHANGED: 'تم تغيير كلمة المرور بنجاح',
			NUMBER_CHANGED: 'تم تغيير رقم الجوال بنجاح',
			OTP_SENT: 'تم إرسال رمز التحقق إلى رقم الجوال',
			PROFILE_UPDATED: 'تم تحديث بيانات الملف الشخصي بنجاح',
		},
		SHAREHOLDERS_REGISTRY: {
			ADD: 'إضافة سجل المساهمين',
			ADDED: 'سجل المساهمين المرسل الى النظام',
			ADD_DESC: 'يمكنك إضافة المساهمين يدويا او رفع السجل في النظام',
			DOWNLOAD_TEMPLATE: 'تحميل القالب',
			TOTAL_TREASURY_NUM: 'العدد الإجمالي لأسهم الخزينة',
			SAVE_FOR_LATER: 'حفظ لاحقاً',
			ADD_NEW_SHAREHOLDER: 'إضافة مساهم',
			ADD_ALL_DATA_MANUALLY: 'فضلا ادخال بيانات المساهم بشكل صحيح',
			SEND_FOR_REVIEW: 'إرسال للمراجعة',
			UPLOAD_DATA: 'رفع البيانات',
			NONE: 'لا شئ',
			MEMBER: 'عضو',
			CHAIRMAN: 'رئيس',
			TOTAL_TREASURY_SHARES_UPDATED: 'تم تحديث إجمالي عدد أسهم الخزينة',
			SHAREHOLDER_ADDED: 'تم إضافة بيانات المساهم بنجاح',
			SHAREHOLDER_UPDATED: 'تم تحديث بيانات المساهم بنجاح',
			SAVED_FOR_LATER: 'تم حفظ قائمة المساهمين للرجوع إليها لاحقًا',
			SENT_FOR_REVIEW_SUCCESS: 'تم إرسال قائمة المساهمين للمراجعة بنجاح',
			DELETE_SHAREHOLDER_CONFIRM: 'هل أنت متأكد أنك تريد حذف هذا المساهم؟',
			SHAREHOLDER_DELETED: 'تم حذف المساهم بنجاح',
			TOTAL_SHAREHOLDERS: 'إجمالي عدد المساهمين',
			REMAINING_SHARES: 'عدد الأسهم المتبقية',
			MORE_SHARES_AVAILABLE: 'هناك {{shares}} أسهم أخرى تحتاج إلى التوزيع',
			EXCEEDS_REMAINING_SHARES: 'تجاوزت عدد الأسهم المتبقة : {{num}}',
			MAX_TREASURY_NUM: 'أسهم الخزينة لا تتعدى 10% من عدد الأسهم الكلي',
			NO_DATA_ENTERED: 'لا توجد بيانات مدخلة',
			OWNED_SHARES: 'الأسهم المملوكة',
			SHAREHOLDER_COMMON_SHARES: 'الأسهم العادية المملوكة للمساهم',
			FREE: 'الحرة',
			SUSPENDED: 'المعلقة',
			MORTGAGED: 'المرهونة',
			TOTAL_OWNED_SHARES: 'إجمالي الأسهم المملوكة',
			REMAINING: 'متبقي',
			FROM: ' من',
			ALL_SHARES_ALLOCATED: 'تم أدخال ملكية {{num}} سهم بالكامل',
			ALL_SHARES_ALLOCATED_TOOLTIP: 'تم أدخال ملكية الأسهم بالكامل',
		},
		DASHBOARD: {
			CURRENT_PLAN: 'الباقة الحالية',
			UPGRADE_TO_BUSINESS_PLAN: 'الترقية الي باقة الأعمال',
			ACCOUNT_UNDER_REVIEW: 'حسابك قيد المراجعة',
			ACCOUNT_UNDER_REVIEW_DESC: 'متطلبات التسجيل تحت المراجعة وسيتم ارسال رسالة نصية في حال قبول الطلب',
			ACCOUNT_REJECTED: 'تم رفض حسابك',
			SHAREHOLDERS_REJECTED: 'تم إعادة سجل المساهمين .. فضلا التحقق من صحته',
			ACCOUNT_BLOCKED: 'تم حظر حسابك',
			UPDATE_DOCUMENT: 'طلب تعديل المستندات',
			UPLOAD_VALID_DOCUMENTS: 'فضلا رفع مستندات صحيحه لمراجعه طلبك.',
			ACCOUNT_APPROVED: 'تم اعتماد حسابك',
			ACTIVATE_ACCOUNT: 'عزيزى المستخدم تم اعتماد حساب الشركة فضلا تفعيله.',
			ACTIVATE_MODAL_TITLE: 'ابدا الاشتراك الان',
			ACTIVATE_MODAL_SUBTITLE: 'يرجى تأكيد بدء اشتراكك',
			START_DATE: 'تاريخ انفاذ العقد',
			DAILY_CHANGE: 'التغير اليومي',
			AVERAGE_SALE_PRICE: 'متوسط سعر السهم',
			SHAREHOLDERS: 'المساهمين',
			TRANSACTIONS: 'المعاملات',
			LAST_SHARE_PRICE: 'آخر سعر للسهم',
			TOTAL_SHARES: 'إجمالي الأسهم',
			CAPITAL: 'رأس المال',
			NUMBER_OF_SHARES: 'عدد الأسهم',
			TREASURY_SHARES: 'أسهم الخزينة',
			YEAR: 'سنة',
			ANNUAL_TRAFFIC: 'الحجم السنوي',
			CUSTOMER_SUPPORT: 'خدمة العملاء',
			QUICK_ACTIONS: 'الاجراءات السريعة',
			ACCOUNT_MANGER_INF: 'معلومات مدير الحساب',
			FOR_ADMINISTRATIVE_SUPPORT: 'للدعم الاداري',
			TECHNICAL_SUPPORT: 'الدعم التقني',
			FOR_TECHNICAL_INQUIRY: 'للطلبات التقنية',
			EMERGENCY_REQUEST: 'التواصل الطارئ',
			EMERGENCY_ESCALATION: 'للحالات الطارئة يمكنك ارسال رسالة نصية لمدير حفظ (فضلا عدم سوء استخدام الخدمة)',
			CONTACT_INF: 'معلومات الاتصال',
			ACCOUNT_MANAGER_NAME: 'اسم مدير الحساب',
			SEND_EMAIL_TO_TECH: 'ارسال بريد الكتروني للفريق التقني',
			DESCRIPTION: 'الوصف',
			SEND_URGENT_REQUEST: 'ارسال طلب طارئ',
			SEND_URGENT_REQUEST_DESC: 'ارسال طلب طارئ لمدير حفظ',
			REMAINING_MESSAGES: 'متبقي {{num}} رسالة',
			MESSAGE: 'الرسالة',
			SEND_EMAIL: 'إرسال بريد إلكتروني',
			SEND_MESSAGE: 'إرسال الرسالة',
			START_NOW: 'بدء إنفاذ الإتفاقية حالاً',
			DAY: 'يوم',
			WEEK: 'أسبوع',
			MONTH: 'شهر',
			SIX_MONTHS: '6 أشهر',
			LAST_PRICE: 'آخر سعر',
			TECHNICAL_SUPPORT_SUCCESS: 'تم إرسال طلب الدعم الفني بنجاح',
			TECHNICAL_SUPPORT_FAILED: 'فشل طلب الدعم الفني الخاص بك',
			EMERGENCY_REQUEST_SUCCESS: 'تم إرسال طلب الطوارئ بنجاح',
			EMERGENCY_REQUEST_FAILED: 'فشل طلب الطوارئ الخاص بك',
			NO_REMAINING_MESSAGES: 'لقد وصلت إلى حد الرسائل اليومية المسموح بها',
			MESSAGE_TOO_SHORT: 'يرجى إدخال رسالة أطول للمتابعة',
			SHAREHOLDERS_WAITING_APPROVAL: 'المساهمون في انتظار الموافقة الإدارية حاليًا',
			UPDATE_SHAREHOLDERS_REGISTRY_DESC: 'يرجى تحديث سجل المساهمين الخاص بك لتفعيل حسابك',
			UPDATE_SHAREHOLDERS_REGISTRY: 'تحديث سجل المساهمين',
			PLEASE_ADD_SHAREHOLDERS: 'فضلا إضافة سجل مساهمي الشركة ',
			YOU_CAN_UPLOAD_SHAREHOLDERS: 'من هنا يمكنك رفع سجل المساهمين وارساله الى النظام ',
			PLEASE_UPLOAD_DOCUMENTS: 'فضلا ارفاق مستندات الشركة',
			YOU_CAN_UPLOAD_DOCUMENTS: 'من هنا يمكنك رفع مستندات الشركة وارسالها الى النظام',
			SHAREHOLDERS_UPLOADED: 'تم ادخال سجل مساهمي الشركة وارسالة للنظام بنجاح ويمكنك الاطلاع عليه .',
			DOCUMENTS_UPLOADED: 'تم رفع مستندات الشركة وارسالها للنظام بنجاح ويمكنك الاطلاع عليها .',
			DOCUMENTS_REJECTED: 'يوجد طلب تعديل مستند .. فضلا الاطلاع على الطلب ',
			SHAREHOLDERS_APPROVED: 'تم اعتماد سجل المساهمين بنجاح ويمكنك الاطلاع عليه .',
			SHAREHOLDERS_SHARES: 'أسهم المساهمين',
			TOTAL_CAPITAL_SHARES: 'إجمالي أسهم رأس المال',
		},
		WALLET: {
			PACKAGE: 'الباقة',
			BASIC_PACKAGE: 'الباقة الأساسية',
			ADVANCED_PACKAGE: 'الباقة المتقدمة',
			BUSINESS_PACKAGE: 'باقة الأعمال',
			BUY_CUSTOM_POINTS: 'شراء نقاط محددة',
			BUY_NOW: 'أشحن',
			INVOICE_NUMBER: 'رقم الفاتورة',
			TRANSACTIONS: 'المعاملات',
			GATEWAY: 'بوابة الدفع',
		},
		ACTIONS: {
			SHAREHOLDER_INFO: 'معلومات مساهم',
			REGISTRY_TRANSACTIONS: 'قيد حركة سهم',
			HEIRS_TRANSFER: 'قيد حركة ورثة',
			SUSPEND: 'تعليق',
			NOTICE: 'تبليغ',
			ANNOUNCEMENT: 'الإعلانات',
			UPDATE_DOCUMENTS: 'تحديث المستندات',
			FINANCIAL_STATEMENT: 'القوائم المالية',
			NEW_REQUEST: 'طلب جديد',
			VIEW_SHAREHOLDERS: 'عرض معلومات مساهم وإنشاء شهادة الملكية',
			UNLIMITED: 'غير محدود',
			REQUEST_CODE: 'كود الطلب',
			REQUEST_DATE: 'تاريخ الطلب',
			SHAREHOLDER_NATIONAL_ID: 'الهوية الوطنية للمساهم',
			SHAREHOLDER_NAME: 'اسم المساهم',
			FILL_TO_BUILD: 'فضلاً، املأ البيانات لإكمال الطلب',
			SHAREHOLDER_CERTIFICATE: 'شهادة المساهم',
			SELLER_NATIONAL_ID: 'هوية البائع',
			SELLER_NAME: 'البائع',
			BUYER_NAME: 'المشتري',
			BUYER_NATIONAL_ID: 'هوية المشتري',
			TRANSFER_SHARES_DESC: 'اجراء عملية نقل اسهم الشركة بين المستثمرين',
			AVAILABLE_SHARES: 'عدد الأسهم المتوفرة',
			SHARES_COUNT: 'عدد الاسهم',
			SHARE_PRICE: 'سعر السهم',
			DECEASED_EQUITY: 'توزيع حقوق المتوفى على الورثة',
			NAME_OF_DECEASED: 'اسم المساهم المتوفى',
			FILL_DETAILS_TO_VALIDATE_ORDER: 'فضلاً، املأ البيانات للتحقق من طلبك',
			DECEASED_NATIONAL_ID: 'الهوية الوطنية للمتوفى',
			DECEASED_EQUITY_INF: 'معلومات عن حقوق الملكية للمتوفى',
			COUNT_OF_COMMON_SHARES: 'الأسهم العادية',
			COUNT_OF_PREFERRED_SHARES: 'الأسهم الممتازة',
			DETERMINE_HEIRS: 'حصر الورثة',
			ESTATE_DISTRIBUTION: 'توزيع التركة',
			NO_OF_HEIRS: 'عدد الورثة: {{num}}',
			HEIR: 'وريث',
			HEIR_NAME: 'الوريث',
			ADD_HEIR: 'إضافة وريث ({{num}})',
			FREE_COMMON_SHARES_COUNT: 'الأسهم العادية الحرة',
			FREE_PREFERRED_SHARES_COUNT: 'الأسهم الممتازة الحرة',
			SUSPENDED_COMMON_SHARES_COUNT: 'الأسهم العادية المعلقة',
			SUSPENDED_PREFERRED_SHARES_COUNT: 'الأسهم الممتازة المعلقة',
			MORTGAGED_COMMON_SHARES_COUNT: 'الأسهم العادية المرهونة',
			MORTGAGED_PREFERRED_SHARES_COUNT: 'الأسهم الممتازة المرهونة',
			SUSPEND_COMPANY_SHARES: 'تعليق أسهم الشركة',
			FOR_ALL: 'للكل',
			GENERAL_SUSPEND: 'تعليق عام',
			SPECIFIC_SUSPEND: 'تعليق مخصص',
			GENERAL: 'عام',
			ALL_COMPANY_SHARES: 'تعليق كافة الاسهم في الشركة',
			SPECIFIC: 'مخصص',
			SPECIFIC_INVESTOR_SHARES: 'تعليق مخصص في الشركة',
			GENERAL_SUSPENSION: 'تعليق الشركة بالكامل',
			SPECIFIC_SUSPENSION: 'تعليق مخصص',
			SUSPEND_REASON: 'سبب التعليق',
			UPLOAD_DOCUMENTS: 'رفع المستندات',
			UPLOADED_DOCUMENTS: 'المستندات المرفوعة',
			DOCUMENT_TITLE: 'عنوان المستند',
			UPLOAD_ANOTHER_FILE: 'رفع ملف آخر',
			COST: 'التكلفة',
			REMAINING_TRANSACTIONS: 'العمليات المتبقية',
			TRANSACTIONS: 'عملية',
			TRANSACTION: 'عملية',
			SUSPEND_ALL_COMMON_SHARES: 'تعليق كافة الأسهم العادية',
			SUSPEND_ALL_PREFERRED_SHARES: 'تعليق كافة الأسهم الممتازة',
			CANCELLED_AT: 'تم الغاء في',
			BY: 'بواسطة',
			SEND_OFFICIAL_NOTICE: 'إرسال إشعار رسمي',
			SEND_NOTICE_TO_ALL_SHAREHOLDERS: 'إرسال تبليغ لكل المساهمين',
			SEND_NOTICE_TO_SPECIFIC_SHAREHOLDER: 'إرسال تبليغ لمساهم معين',
			INVESTOR_MESSAGE: 'رسالة المستثمر',
			MESSAGE: 'الرسالة',
			REMAINING: 'متبقي',
			DOCUMENT_TYPE: 'نوع المستند',
			TO_UPDATE_COMPANY_DOCUMENTS: 'لتحديث مستندات الشركة',
			UPDATE_COMPANY_DOCUMENT: 'تحديث مستندات الشركة',
			FILL_THESE_DETAILS_TO_UPDATE_COMPANY_DOCUMENTS: 'املأ هذه البيانات لتحديث مستندات الشركة',
			COMMERCIAL_REGISTRATION: 'السجل التجاري',
			LICENSES: 'الرخص',
			CURRENT_COMPANY_ESTABLISHMENT_CONTRACT: 'عقد تأسيس الشركة الحالى',
			ADMINISTRATIVE: 'إدارية',
			CONTRACT: 'عقود',
			FINANCIAL: 'مالية',
			VAT_REGISTRATION_CERTIFICATE: 'شهادة التسجيل في ضريبة القيمة المضافة',
			CHAIRMAN_SIGNATURE: 'توقيع رئيس مجلس الإدارة',
			SEND_FOR_REVIEW: 'إرسال للمراجعة',
			SHOW_ON_PLATFORM_CONNECTED_TO_HEFTH: 'عرضها على المساهمين في المنصات المرتبطة بحفظ',
			TAX_REGISTRATION_NUMBER: 'الرقم الضريبي',
			CHAIRMAN_NAME_AR: 'إسم رئيس مجلس الإدارة بالعربية',
			CHAIRMAN_NAME_EN: 'إسم رئيس مجلس الإدارة الإنجليزية',
			APPOINTMENT_DECISION: 'قرار التعيين',
			CHAIRMAN_SIGNATURE_DESC: 'سيتم عرض هذا التوقيع في شهادات المليكة واي مستندات اخرى تحمل توقيع رئيس مجلس الادارة',
			UPDATE_COMPANY_DOCUMENTS_DETAILS: 'تفاصيل تحديث مستندات الشركة',
			ANNUAL: 'سنوي',
			SEMI_ANNUAL: 'نصف سنوي',
			QUARTER: 'ربع سنوي',
			TO_ADD_FINANCIAL_STATEMENTS: 'لاضافة القوائم المالية',
			PUBLISH_FINANCIAL_STATEMENT: 'نشر قوائم مالية',
			FILL_TO_REVIEW: 'فضلاً إكمال الطلب للمراجعة',
			ASSEMBLY_FILL_TO_REVIEW: 'فضلاً، عبّئ البيانات لجدولة الجمعية',
			PUBLIC: 'للعامة',
			PUBLIC_DESC: 'نشر القوائم في موقع حفظ الرسمي و ملف الشركة بتطبيقات المستخدمين',
			TO_SENT_TO_SHAREHOLDERS: 'نشر القوائم للمساهمين و ملف الشركة في التطبيقات',
			PERIOD: 'الفترة الزمنية',
			INTERNAL: 'داخلية',
			AUDITED: 'مدققة',
			UPLOAD_FINANCIAL_STATEMENT: 'رفع القوائم المالية',
			FINANCIAL_STATEMENT_DETAILS: 'تفاصيل القوائم المالية',
			AUDIENCE: 'الجمهور',
			YEAR: 'السنة',
			QUARTER_ONE: 'الربع الأول',
			QUARTER_TWO: 'الربع الثاني',
			QUARTER_THREE: 'الربع الثالث',
			QUARTER_FOUR: 'الربع الرابع',
			PUBLISH_ANNOUNCEMENT: 'انشر إعلان شركتك للعامة',
			NOTIFIED_BY_SMS: 'تم الإخطار عن طريق SMS',
			FREE_PUBLIC: 'نشر مجاني',
			PUBLISH_TO_PUBLIC: 'النشر للعامة في حفظ والمنصات ذات الصلة',
			BROADCAST_ANNOUNCEMENT: 'ارسال رسالة نصية لمساهمي الشركة',
			NOTIFY_SHAREHOLDERS: 'تبليغ المساهمين',
			TRANSACTION_CALCULATOR: '{{shareholders}} مستخدم  ✕ {{transactions}} نقطه   = {{total}} نقطه ',
			USAGE_CALCULATOR: 'التكلفة : {{cost}} عملية من {{remaining}} عمليات متبقية',
			COST_PER_SMS: 'التكلفة لكل رسالة',
			POINT_PER_SMS: '{{point}} نقطة لكل رسالة',
			TRANSACTIONS_PER_SMS: '1 عملية لكل رسالة',
			ANNOUNCEMENT_DETAILS: 'تفاصيل الإعلان',
			AWARE_THIS_CONTENT_BE_PUBLIC: 'يرجى العلم بأن هذا المحتوى سيتم نشره للعامة',
			TITLE_IN_AR: 'العنوان بالعربية',
			TITLE_IN_EN: 'العنوان بالإنجليزية',
			EXCERPT_IN_AR: 'المقتطفات بالعربية',
			EXCERPT_IN_EN: 'المقتطفات بالإنجليزية',
			CONTENT_IN_AR: 'المحتوى بالعربية',
			CONTENT_IN_EN: 'المحتوى بالإنجليزية',
			ADD_ANNOUNCEMENT_IN_ENGLISH: 'إضافة الإعلان باللغة الإنجليزية',
			ASSEMBLIES: 'الجمعيات',
			TO_ADD_ASSEMBLIES: 'لاضافة جمعية عمومية',
			FILL_TO_CREATE_ASSEMBLIES: 'قم باضافة البيانات لاضافة جمعية',
			TYPE_OF_ASSEMBLY: 'نوع الجمعية',
			ORDINARY: 'عادية',
			ORDINARY_ASSEMBLY: 'جمعية عادية',
			EXTRAORDINARY: 'غير عادية',
			EXTRAORDINARY_ASSEMBLY: 'جمعية غير عادية',
			ATTENDANCE_QUORUM: 'نصاب الجمعية',
			NON_ACCUMULATIVE_VOTING: 'نسبة استكمال النصاب للجمعية الغير تراكمي',
			ACCUMULATIVE_VOTING: 'نسبة استكمال النصاب للجمعية التراكمي',
			CHOOSE_ASSEMBLY_DATE: 'تاريخ ووقت انعقاد الجمعية',
			TIME: 'التوقيت',
			LOCATION: 'مكان انعقاد الاجتماع',
			ONLINE: 'عن بعد',
			ONLINE_MEETING: 'اجتماع عن بعد',
			PHYSICAL: 'حضوري',
			PHYSICAL_MEETING: 'اجتماع حضوري',
			AGENDA_FOR_MEETING: 'جدول أعمال الجمعية',
			ADD_ALL_FILES_TO_ASSEMBLY: 'فضلاً، أضف جميع المستندات الخاصة بالجمعية لعرضها على المساهمين',
			ALL_FILES_TO_ASSEMBLY: 'جميع الملفات المرتبطة بالجمعية',
			POINT_IN_AR: 'البند باللغة العربية',
			POINT_IN_EN: 'البند باللغة الانجليزية',
			SHAREHOLDER_COUNT: 'تصويت تراكمي',
			ADD_ANOTHER_POINT: 'إضافة بند آخر',
			ADD_A_POINT: 'اضافة بند',
			ADDRESS: 'العنوان',
			ADDRESS_DESC: 'وصف العنوان',
			ASSEMBLY_DATE: 'تاريخ الجمعية',
			ASSEMBLY_TYPE: 'نوع الجمعية',
			DIVIDENDS: 'توزيع الأرباح',
			ELP: 'الولاء (قريباً)',
			CAPITALS: 'رأس المال',
			MORTGAGE: 'الرهن (قريباً)',
			YES: 'نعم',
			NO: 'لا',
			ABSTAINED: 'ممتنع',
			ASSEMBLY_QUORUM_COMPLETE_PERCENTAGE: 'نسبة اكتمال النصاب القانوني للجمعية',
			QUORUM_NOT_MET: 'لم يكتمل النصاب',
			ASSEMBLY_QUORUM_NOT_COMPLETE: 'نصاب الجمعية لم يكتمل بعد',
			QUORUM_MET: 'اكتمل النصاب',
			COPY_LINK: 'نسخ الرابط',
			ASSEMBLY_ATTENDANCE: 'حضور الجمعية',
			ATTEND_TYPE: 'تم تسجيل الحضور من قبل',
			ASSEMBLY_SHAREHOLDER: 'المساهم نفسه',
			ATTEND_AT: 'توقيت تسجيل الحضور',
			SHAREHOLDER: 'المساهم نفسه',
			COMPANYUSER: 'الشركة',
			ASSEMBLY_ATTENDANT_DETAILS: 'تفاصيل الحضور',
			ATTEND_BY: 'تم تسجيل الحضور من قبل',
			DELEGATE_NAME: 'اسم المفوض',
			DELEGATION_DOCUMENT: 'مستند التفويض',
			ADD_ASSEMBLY_ATTENDANCE: 'اضافة حضور الجمعية',
			SEARCH_BY_NATIONAL_ID_OR_NAME: 'ابحث برقم الهوية الوطنية او الاسم',
			IS_DELEGATE_ATTENDANCE: ' الحضور بالانابة',
			DELEGATE_FILE: 'ملف التفويض',
			SHAREHOLDER_FULL_NAME: 'اسم المساهم الكامل',
			OPEN_ATTENDANCE: 'فتح الحضور',
			OPEN_VOTING: 'فتح التصويت',
			ADD_VOTE: 'اضافة تصويت',
			DOWNLOAD_DOCUMENTS: 'تحميل المستندات',
			VOTING_ITEMS: 'بنود التصويت',
			EACH_SHAREHOLDER_REPRESENT_ONE_VOTE: 'كل مساهم يمثل صوت واحد',
			SHAREHOLDER_NOT_FOUND: 'المساهم غير موجود',
			SELLER_AND_BUYER_CANNOT_BE_SAME: 'لا يمكن أن يكون البائع والمشتري نفس المساهم',
			SHARES_COUNT_REQUIRED: 'عدد الأسهم مطلوب',
			SHARE_PRICE_REQUIRED: 'سعر السهم مطلوب',
			COMPANY_SHARES_LIMIT_EXCEEDED: 'عدد الأسهم يتجاوز الحد الأقصى المتاح للمشتري (المتبقي {{count}} سهم)',
			SHAREHOLDER_LIMIT_EXCEEDED_TITLE: 'تجاوز نسبة الأسهم للمشتري',
			SHAREHOLDER_LIMIT_EXCEEDED_DESCRIPTION: 'نسبة الأسهم تخطت نسبة الأسهم المتاحة للمساهمين وتحتاج موافقة',
			SHAREHOLDER_LIMIT_EXCEEDED_APPROVE: 'اقر بدرايتي الكاملة و توافق العملية مع نظام الجمعيات التعاونية السعودي',
			REGISTRY_TRANSACTION_CREATED: 'تم إنشاء قيد حركة السهم بنجاح',
			HAS_PENDING_REQUEST: 'يوجد طلب تحت المراجعة',
			UPDATE_DOCUMENT_SUCCESS: 'تم إرسال طلب تحديث المستند بنجاح',
			TAX_REGISTRATION_NUMBER_LEN: 'رقم تسجيل ضريبه القيمه المضافه يجب أن يتكون من 15 أرقام',
			VERIFICATION: 'التحقق',
			CONFIRM_YOUR_REQUEST: 'اختر طريقة التحقق الخاصة بك',
			PASSWORD: 'كلمة المرور',
			OTP: 'رمز التأكيد المؤقت',
			SEND_OTP: 'إرسال رمز التأكيد',
			ENTER_YOUR_PASSWORD: 'أدخل كلمة المرور الخاصة بك',
			VALIDATE: 'تحقق',
			OTP_SENT: 'تم إرسال رمز التحقق إلى رقم الجوال',
			OTP_NOT_SENT: 'حدث خطأ أثناء إرسال رمز التحقق إلى رقم الجوال',
			FINANCIAL_STATEMENT_EXISTS: 'تقرير مالي لهذه الفترة موجود بالفعل',
			FINANCIAL_STATEMENT_CREATED: 'تم إنشاء التقرير المالي بنجاح',
			HEIR_TRANSFER_NOT_EXIST: 'طلب نقل الورثة غير موجود',
			SHAREHOLDER_GENERATED_SUCCESSFULLY: 'تم إنشاء المساهم بنجاح',
			HEIR_TRANSFER_CREATED: 'تم إنشاء طلب نقل الورثة بنجاح',
			SELECT_ONE_AT_LEAST: 'حدد وريث واحد على الأقل',
			ALL_SHARES_MUST_BE_DISTRIBUTED: 'يجب توزيع جميع أسهم المتوفي على الورثة قبل الإرسال',
			PENDING_TRANSACTION: 'معاملات قيد الانتظار',
			PENDING_TRANSACTION_DESC: 'يوجد معاملات قيد الانتظار للمتوفي',
			PENDING_COMMON_SHARES: 'اسهم عادية معروضة',
			PENDING_PREFERRED_SHARES: 'اسهم ممتازة معروضة',
			CANCEL_PENDING_TRANSACTIONS: 'إلغاء المعاملات المعلقة',
			CANCEL_TRANSACTIONS_DECEASED: 'سيتم إلغاء جميع المعاملات المعلقة للمتوفي',
			PENDING_TRANSACTION_CANCELLED: 'تم إلغاء المعاملات المعلقة للمتوفي بنجاح',
			CANT_USED_DECEASED_NATIONAL_ID: 'الهوية الوطنية يعود للشخص المتوفي، لذا لا يمكن استخدامه.',
			CANCEL_REQUEST: 'إلغاء الطلب',
			CANCEL_REQUEST_NOTE: 'عند تاكيد طلب الالغاء يمكن لكل المساهمين التصرف بملكيتهم بشكل فوري. فضلا التاكد من سلامة الاجراء.',
			CANCEL_SUSPEND_REASON: 'سبب إلغاء التعليق',
			SUPPORTED_DOCUMENTS: 'المستندات الداعمة',
			SUSPEND_ACTION_CANCELLED: 'تم إلغاء التعليق',
			SUSPEND_CREATED_SUCCESSFULLY: 'تم إنشاء طلب التعليق بنجاح',
			NOTICE_CREATED: 'تم إنشاء الإشعار بنجاح',
			MESSAGE_LENGTH_VALIDATION: 'يجب أن يتكون طول الرسالة من 10 أحرف على الأقل',
			SMS_ENABLED: 'الرسائل النصية (SMS مفعلة)',
			WHEN_YOU_PUBLISH: 'عند نشرك للاعلان سيصل رسالة (SMS) لمساهمين الشركة',
			WAITING_FOR_PUBLISH: '(بإنتظار النشر)',
			PUBLISH: 'نشر',
			CANCEL_ANNOUNCEMENT_PUBLISH_CONFIRMATION: 'هل أنت متأكد!',
			CANT_REPUBLISH_AGAIN: 'إلغاء نشر الإعلان',
			ANNOUNCEMENT_CANCELLED_SUCCESSFULLY: 'تم إلغاء الإعلان بنجاح',
			ANNOUNCEMENT_PUBLISHED_SUCCESSFULLY: 'تم نشر الإعلان بنجاح',
			CONFIRM_SEND_SHAREHOLDERS: 'قم بتأكيد طلبك بإرسال رسائل نصية قصيرة (SMS) إلى المساهمين.',
			I_AGREE_TO_TERMS: 'أوافق على الشروط والأحكام وسياسة الخصوصية.',
			AGREE_FIRST: 'يرجى الموافقة على الشروط والأحكام أولاً.',
			ANNOUNCEMENT_CREATED: 'تم إنشاء الإعلان بنجاح',
			CANCEL_ASSEMBLY: 'إلغاء الجمعية',
			CONFIRM_CANCEL_ASSEMBLY: 'هل انت متاكد من الغاء هذه الجمعية؟',
			ASSEMBLY_CANCELLED: 'تم إلغاء الجمعية بنجاح',
			ASSEMBLY_NOT_CANCELLED: 'حدث خطأ أثناء إلغاء الجمعية.',
			CANT_UNDO: 'لا يمكن استرجاع الجمعية بعد إلغائها.',
			SEARCH_FOR_PLACE: 'البحث عن مكان',
			PRESIDENT_OF_ASSEMBLY_NAME: 'رئيس الجمعية',
			GENERAL_SECRETARY_NAME: 'أمين السر',
			VOTE_COLLECTOR_NAME: 'جامع الأصوات',
			PRESIDENT_OF_ASSEMBLY_SIGNATURE: 'توقيع رئيس الجمعية',
			GENERAL_SECRETARY_SIGNATURE: 'توقيع أمين السر',
			VOTE_COLLECTOR_SIGNATURE: 'توقيع جامع الأصوات',
			QUORUM_PERCENTAGE: 'النصاب',
			BOARD_ABSTENTION: 'امتناع مجلس الادارة',
			SELECT_AT_LEAST_ONE_LOCATION: 'حدد موقع واحد على الأقل',
			ASSEMBLY_CREATED: 'تم إنشاء الجمعية بنجاح',
			ASSEMBLY_UPDATED: 'تم تحديث الجمعية بنجاح',
			SIGNATURE: 'التوقيع',
			ERROR_FETCHING_ASSEMBLY: 'حدث خطأ أثناء جلب بيانات الجمعية.',
			ATTENDANCE: 'الحضور',
			VOTING_OPENED_SUCCESS: 'تم فتح التصويت بنجاح',
			VOTING_OPENED_FAILED: 'فشل فتح التصويت',
			ATTENDANCE_OPENED_SUCCESS: 'تم فتح الحضور بنجاح',
			ATTENDANCE_OPENED_FAILED: 'فشل فتح الحضور',
			COMPANY: 'الشركة',
			ATTENDEES: 'الحضور',
			OWNS: 'يمتلكون',
			DECISION_IN_AR: 'القرار باللغة العربية',
			DECISION_IN_EN: 'القرار باللغة الإنجليزية',
			DECISION: 'قرار',
			CURRENT_VOTING_RESULT: 'نتيجة التصويت الحالية',
			ATTENDANCE_VOTING_STATUS: 'حالة تصويت الحضور',
			VOTED_USERS: 'قاموا بالتصويت',
			NOVOTE: 'لم يصوت',
			NO_VOTE: 'لم يصوت',
			NUMBER_OF_SHAREHOLDER_ADDED_VOTES: 'عدد المساهمين الذين قاموا بالتصويت',
			NUMBER_OF_SHAREHOLDER_ADDED_NO_VOTES: 'عدد المساهمين الذين لم يصوتون',
			ERROR_ENDING_VOTING: 'حدث خطأ أثناء إنهاء التصويت.',
			CLOSE_VOTING: 'إغلاق التصويت',
			CLOSE_ASSEMBLY: 'إغلاق الجمعية',
			COPIED: 'تم النسخ',
			COST_POINTS: 'التكلفة {{num}} نقطة',
			FREE_ACTIONS: 'عملية مجانية',
			UPGRADE_TO_PLAN: 'عند الترقية إلى باقة {{name}}',
			VOTTING_DETAILS: 'بيانات التصويت',
			ATTENDEE_ADDED_SUCCESSFULLY: 'تم إضافة الحضور بنجاح',
			VOTING_ENDED_SUCCESSFULLY: 'تم إنهاء التصويت بنجاح',
			ASSEMBLY_CLOSED_SUCCESSFULLY: 'تم إغلاق الجمعية بنجاح',
			ERROR_CLOSING_ASSEMBLY: 'حدث خطأ أثناء إغلاق الجمعية.',
			QUORUM_MUST_BE_ATLEAST: 'يجب أن يكون نصاب الجمعية {{num}}% على الأقل',
			CANT_ACCESS_ASSEMBLIES_SERVICE: 'لا يمكنك الوصول إلى خدمة الجمعيات.',
			DISCOUNT: 'خصم',
			FETCH_DECISION_ERROR: 'حدث خطأ أثناء جلب بيانات القرارات.',
			SUBMIT_SHAREHOLDER_VOTE: 'إضافة تصويت المساهم',
			VOTE_ADDED_SUCCESSFULLY: 'تم إضافة تصويت المساهم بنجاح',
			ASSEMBLY_FILES: 'ملفات الجمعية',
			DOWNLOAD_ASSEMBLY_FILES: 'تحميل الملفات الخاصة بالجمعية',
			COMPLETION_PROGRESS: 'نسبة اكتمال انشاء الملفات',
			AVAILABLE_FILES: '{{num}} من 4 ملفات متاحة',
			ATTENDANCE_PDF: 'حضور الجمعية',
			DECISIONS_RESULTS_PDF: 'محضر جمع الاصوات',
			SHAREHOLDER_VOTING_CARDS: 'بطاقات تصويت المساهمين',
			DECISIONS_COMMENTS_PDF: 'محضر الجمعية',
			NOT_READY_YET: 'ليس جاهزًا بعد',
			AUTO_PUBLISH: 'النشر التلقائي',
			DAYS: 'يوم',
			HOURS: 'ساعة',
			MINUTES: 'دقيقة',
			SECONDS: 'ثانية',
			AUTO_PUBLISH_TIME: 'وقت النشر التلقائي',
			DECISIONS: 'القرارات',
			ALL_DECISIONS_IN_ASSEMBLY: 'جميع القرارات في الجمعية',
			ASSEMBLY_LESS_THAN_21_DAYS_WARNING:
				'ينص نظام الشركات السعودي - المادة الحادية والتسعون - الفقرة الاولى على ان يتم دعوة المساهمين للجمعية العمومية عن الميعاد المحدد بمدة لا تقل عن -٢١- يوما و جدولتها وانعقادها قبل ذلك يقع على عاتق الشركة وحدها مسؤولية انعقادها',
			COMPANY_SUSPEND: 'عمليات الشركة',
			SYSTEM_SUSPEND: 'عمليات النظام',
			SYSTEM_SUSPEND_DESC: 'العمليات التي قام بها النظام تلقائيا حسب الأنظمة المعمول بها داخل المملكة العربية السعودية.',
			TYPE: 'النوع',
			FOUNDER: 'مؤسس',
			UNDER_AGE: 'تحت السن القانوني',
			FIRST_YEAR_AUDITED_STATEMENT: 'قوائم السنة المالية المدققة الاولى',
			SECOND_YEAR_AUDITED_STATEMENT: 'قوائم السنة المالية المدققة الثانية',
			ALL_SHARES_SUSPENDED: 'كافة الأسهم معلقة',
			ASSEMBLY_PUBLISHED_SUCCESSFULLY: 'تم نشر الجمعية بنجاح',
			ERROR_PUBLISHING_ASSEMBLY: 'حدث خطأ أثناء نشر الجمعية.',
			BOARDS: 'مجلس الإدارة',
			COMMITTEES: 'اللجان',
			BOARDS_AND_COMMITTEES: 'مجلس الإدارة واللجان',
			BOARDS_DESC: 'إملأ هذه التفاصيل لبناء شركتك',
			APPOINT_BOARD: 'تعيين مجلس الإدارة',
			ACTIVE_BOARD: 'مجلس الإدارة النشط',
			BOARD: 'مجلس الإدارة',
			DRAFT_BOARD: 'مسودة مجلس الإدارة',
			BOARD_GOVERNANCE: 'حوكمة مجلس الإدارة',
			BOARD_SETTINGS: 'إعدادات مجلس الإدارة',
			TOTAL_BOARD_MEMBERS: 'إجمالي أعضاء مجلس الإدارة',
			BOARD_OF_DIRECTORS_TERM: 'دورة انعقاد المجلس',
			BOARD_OF_DIRECTORS_TERM_VALIDATION: 'يجب أن تكون دورة انعقاد مجلس الإدارة لا تقل عن سنة واحدة',
			MAXIMUM_EXECUTIVE_MEMBERS: 'الحد الأقصى للأعضاء التنفيذيين',
			MAXIMUM_INDEPENDENT_MEMBERS: 'الحد الأقصى للأعضاء المستقلين',
			MINIMUM_QUORUM_OF_MEETINGS: 'نصاب انعقاد الاجتماعات ',
			MAXIMUM_ABSENCE_BEFORE_NOTIF: 'الحد الأقصى للغياب قبل الإشعار',
			MINIMUM_NOTIF_BEFORE_MEETINGS: 'الحد الأقصى للتنبيه قبل الاجتماع ',
			ALLOW_SWIPE_VOTING: 'السماح بالتصويت بالتمرير ',
			BOARD_MEMBERS: 'أعضاء مجلس الإدارة',
			MEMBERS: 'عضو',
			MEETINGS: 'اجتماع',
			YEARS: 'سنوات',
			BOARD_MEETINGS: 'اجتماعات مجلس الإدارة',
			BOARD_APPOINTMENT: 'تعيين مجلس الإدارة',
			MEMBER_NAME: 'اسم العضو',
			MEMBER_NAME_AR: 'اسم العضو باللغة العربية',
			MEMBER_NAME_EN: 'اسم العضو باللغة الإنجليزية',
			POSITION: 'المنصب',
			APPOINTMENT_DATE: 'تاريخ التعيين',
			BOARD_STRUCTURE: 'هيكل مجلس الإدارة',
			FILL_TO_APPOINT_BOARD: 'املأ هذه التفاصيل لتعيين مجلس إدارة الشركة',
			BOARD_MEMBER_NAME: 'اسم عضو مجلس الإدارة',
			PLEASE_CHOOSE_BOARD_GOVERNANCE: 'يرجى اختيار اعدادات مجلس الإدارة',
			OPTIONAL_SETTINGS_TO_ENHANCE_BOARD_PERFORMANCE: 'إعدادات اختيارية لتحسين أداء مجلس الادارة',
			ALLOW_EXTERNAL_GUEST_INVITATION: 'السماح بدعوة ضيوف خارجيين',
			ALLOW_SECRETARY_UPDATE_WHILE_BOARD_IS_ACTIVE: 'السماح بتغيير السكرتير والمجلس منعقد',
			ADD_BOARD_MEMBERS: 'يرجى إضافة أعضاء مجلس الإدارة',
			ADD_MEMBER: 'إضافة عضو',
			ADD_NEW_MEMBER: 'إضافة عضو جديد',
			MEMBER_NATIONAL_ID: 'الهوية الوطنية للعضو',
			MEMBER_PHONE: 'رقم جوال العضو',
			MEMBER_EMAIL: 'البريد الإلكتروني للعضو',
			MEMBER_TYPE: 'نوع العضو',
			MEMBER_POSITION: 'منصب العضو',
			EXECUTIVE: 'تنفيذي',
			NON_EXECUTIVE: 'غير تنفيذي',
			'NON-EXECUTIVE': 'غير تنفيذي',
			INDEPENDENT: 'مستقل',
			STAFF: 'موظف',
			CHAIRMAN: 'رئيس مجلس الإدارة',
			VICE_CHAIRMAN: 'نائب رئيس مجلس الإدارة',
			SECRETARY: 'أمين السر',
			TREASURER: 'أمين الصندوق',
			MEMBER: 'عضو',
			DELETE_MEMBER: 'حذف العضو',
			CONFIRM_DELETE_MEMBER: 'يرجى تأكيد طلبك',
			MEMBER_DELETE_NOTE:
				'سيكون حذف العضو فعالاً بعد حفظ جميع التغييرات، يرجى العلم أنه بعد حفظ جميع التغييرات لن يتمكن هذا العضو من العودة إلى المجلس إلا إذا قمت بإضافته مرة أخرى.',
			MEMBER_DETAILS: 'تفاصيل العضو',
			TOTAL_BOARD_MEMBERS_VALIDATION: 'يجب أن يضم المجلس ما لا يقل عن 3 أعضاء ولا يتجاوز 15 عضواً.',
			MAXIMUM_ABSENCE_BEFORE_NOTIF_VALIDATION: 'الحد الأقصى للغياب قبل الإشعار يجب ألا يتجاوز 50% من اجتماعات المجلس.',
			MINIMUM_NOTIF_BEFORE_MEETINGS_VALIDATION: 'الحد الأدنى للإشعار قبل الاجتماعات يجب ألا يقل عن 1 يوم.',
			MINIMUM_QUORUM_OF_MEETINGS_VALIDATION: 'النصاب الأدنى للاجتماعات يجب ألا يقل عن 50%.',
			BOARD_MEMBER_CREATED_SUCCESSFULLY: 'تم إنشاء عضو مجلس الإدارة بنجاح',
			BOARD_MEMBER_UPDATED_SUCCESSFULLY: 'تم تحديث عضو مجلس الإدارة بنجاح',
			BOARD_MEMBER_DELETED_SUCCESSFULLY: 'تم حذف عضو مجلس الإدارة بنجاح',
			FETCH_BOARD_DETAILS_ERROR: 'حدث خطأ أثناء جلب تفاصيل مجلس الإدارة.',
			BOARD_APPOINTMENT_FAILED: 'فشل تعيين مجلس الإدارة. يرجى المحاولة مرة أخرى لاحقاً.',
			BOARD_APPOINTED_SUCCESSFULLY: 'تم تعيين مجلس الإدارة بنجاح',
			BOARD_CREATED_SUCCESSFULLY: 'تم إنشاء مجلس الإدارة بنجاح',
			BOARD_APPOINTMENT_VERIFICATION_NOTE:
				'سيكون تعيين مجلس الإدارة الجديد فعالاً بعد التأكيد، يرجى العلم: وفقاً لأنظمة وزارة التجارة السعودية، يجب أن تتم الموافقة على تعيين مجلس إدارة الشركة الجديد من قبل الجمعية العمومية.',
			BOARD_DELETED_SUCCESSFULLY: 'تم حذف مجلس الإدارة بنجاح',
			BOARD_DELETED_FAILED: 'حدث خطأ أثناء حذف مجلس الإدارة.',
			DELETE_BOARD: 'حذف مجلس الإدارة',
			CONFIRM_DELETE_BOARD: 'يرجى تأكيد طلبك لحذف مجلس الإدارة.',
			BOARD_DELETE_NOTE: 'سيكون حذف مجلس الإدارة فعالاً فوراً، يرجى العلم أنه بعد حذف المجلس ستفقد جميع بياناته ولا يمكن استعادتها.',
			NEW_MEETING: 'اجتماع جديد',
			MEETING_DATE: 'تاريخ الاجتماع',
			BOARDS_MEETINGS: 'اجتماعات مجلس الإدارة',
			CODE: 'الكود',
			NEW_BOARD_MEETING: 'اجتماع مجلس إدارة جديد',
			MEETING_FILL_OUT_DETAILS: 'اكمل هذه التفاصيل لجدولة اجتماع جديد',
			MEETING_TYPE: 'نوع الاجتماع',
			SCHEDULED: 'مجدول',
			URGENT: 'عاجل',
			VOTING: 'تصويت',
			FOR_SCHEDULED_MEETINGS: 'للاجتماعات المجدولة',
			IMMEDIATE_ACTION_NEEDED: 'اجتماع يتطلب إجراءً فورياً',
			NO_DELIBERATION_VOTES: 'بدون مداولة، تصويت على القرارات.',
			CHOOSE_STARTING_DATE: 'اختر تاريخ البداية',
			GUEST_INVITATION: 'دعوة الضيوف',
			EXTERNAL_BODIES_NO_VOTING_RIGHTS: 'جهات خارجية للانضمام بدون حقوق تصويت',
			INVITE: 'دعوة',
			ORGANIZATION: 'المؤسسة',
			ADD_NEW_GUEST: 'إضافة ضيف جديد',
			GUEST_DETAILS: 'تفاصيل الضيف',
			GUEST_NAME_AR: 'اسم الضيف بالعربية',
			GUEST_NAME_EN: 'اسم الضيف بالإنجليزية',
			GUEST_EMAIL: 'البريد الإلكتروني للضيف',
			GUEST_PHONE: 'رقم جوال الضيف',
			GUEST_SECTOR: 'قطاع الضيف',
			GUEST_POSITION: 'منصب الضيف',
			GUEST_ORGANIZATION: 'مؤسسة الضيف',
			DELETE_GUEST: 'حذف الضيف',
			CONFIRM_DELETE_GUEST: 'يرجى تأكيد طلبك لحذف الضيف.',
			EDIT_MEMBER: 'تعديل العضو',
			EDIT_GUEST: 'تعديل الضيف',
			MEETING_AGENDA: 'جدول أعمال الاجتماع',
			SCHEDULE: 'جدولة',
			MEETING_CREATED_SUCCESSFULLY: 'تم إنشاء الاجتماع بنجاح',
			VOTING_DURATION: 'مدة التصويت',
			MINUTES_VAR: '{{num}} دقائق',
			HOURS_VAR: '{{num}} ساعات',
			HRS: 'ساعة',
			MINS: 'دقيقة',
			CANCEL_MEETING: 'إلغاء الاجتماع',
			MEETING_CANCELLED: 'تم إلغاء الاجتماع بنجاح',
			CONFIRM_CANCEL_MEETING: 'هل أنت متأكد من إلغاء هذا الاجتماع؟',
			MEETING_NOT_CANCELLED: 'حدث خطأ أثناء إلغاء الاجتماع.',
			CONFIRM_OPEN_VOTING: 'هل أنت متأكد من فتح التصويت لهذا الاجتماع؟',
			CONFIRM_OPEN_ATTENDANCE: 'هل أنت متأكد من فتح الحضور لهذا الاجتماع؟',
			MEETING_UPDATED_SUCCESSFULLY: 'تم تحديث الاجتماع بنجاح',
			STARTING_DATE: 'تاريخ البداية',
			STARTING_DATE_BUY: 'تاريخ بداية عملية الشراء',
			ATTENDING_MEMBERS: 'الأعضاء الحاضرون',
			MEETING_GUESTS: 'ضيوف الاجتماع',
			GUESTS: 'ضيوف',
			MEETING_QUORUM_MET: 'تم استيفاء نصاب الاجتماع',
			MEETING_QUORUM_NOT_MET: 'لم يتم استيفاء نصاب الاجتماع',
			MEETING_FILES: 'ملفات الاجتماع',
			ATTENDANCE_SUMMARY: 'الحضور',
			ADD_MEETING_ATTENDANCE: 'إضافة حضور الاجتماع',
			MEETING_ATTENDANCE: 'حضور الاجتماع',
			MEETING_ATTENDANT_DETAILS: 'تفاصيل حاضر الاجتماع',
			END_VOTING: 'إنهاء التصويت',
			END_MEETING: 'إنهاء الاجتماع',
			CONFIRM_END_MEETING: 'هل أنت متأكد من إنهاء هذا الاجتماع؟',
			CONFIRM_CLOSE_VOTING: 'هل أنت متأكد من إغلاق التصويت لهذا الاجتماع؟',
			VOTING_CLOSING_SUCCESS: 'تم إغلاق التصويت بنجاح',
			MEETING_ENDED_SUCCESSFULLY: 'تم إنهاء الاجتماع بنجاح',
			EDIT_DECISION_COMMENTS: 'تعديل تعليقات القرار',
			ADD_DECISION_COMMENTS: 'إضافة تعليقات القرار',
			COMMENTS_ADDED_SUCCESS: 'تمت إضافة التعليقات بنجاح',
			PREVIOUS_BOARD: 'المجلس السابق',
			USERS: 'المستخدمون',
			USER: 'مستخدم',
			ATTENDEE_TYPE: 'الصفة',
			UPDATE_SECRETARY_ERROR: 'حدث خطأ أثناء تحديث معلومات السكرتير.',
			SECRETARY_UPDATED_SUCCESSFULLY: 'تم تحديث معلومات السكرتير بنجاح.',
			UPDATE_SECRETARY: 'تحديث بيانات السكرتير',
			ASSEMBLY_DESCRIPTION: 'جدولة جمعية عمومية او خاصة جديدة',
			MEETING_DECISION_COMMENTS: 'تعليقات قرار الاجتماع',
			NUMBER_OF_MEMBER_ADDED_NO_VOTES: 'عدد الأعضاء المضافين بدون تصويت',
			NUMBER_OF_MEMBER_ADDED_VOTES: 'عدد الأعضاء المضافين مع تصويت',
			BOARD_DOCUMENTS: ' مستندات مجلس الإدارة',
			NEW_DOCUMENT: 'مستند جديد',
			FILES_COUNT: 'عدد الملفات',
			TITLE: 'العنوان',
			DOCUMENT_DETAILS: 'تفاصيل المستند',
			DESCRIPTION_IN_ARABIC: 'الوصف باللغة العربية',
			DESCRIPTION_IN_ENGLISH: 'الوصف باللغة الإنجليزية',
			DELETE_DOCUMENT: 'حذف المستند',
			CONFIRM_DELETE_DOCUMENT: 'هل أنت متأكد من حذف هذا المستند؟',
			DOCUMENT_DELETED_SUCCESSFULLY: 'تم حذف المستند بنجاح.',
			ERROR_DELETING_DOCUMENT: 'حدث خطأ أثناء حذف المستند.',
			NEW_BOARD_DOCUMENT: 'مستند مجلس إدارة جديد',
			DOCUMENT_CREATED_SUCCESSFULLY: 'تم إنشاء المستند بنجاح',
			UPDATE_BOARD_DOCUMENT: 'تحديث مستند مجلس الإدارة',
			DOCUMENT_UPDATED_SUCCESSFULLY: 'تم تحديث المستند بنجاح',
			ABSTENTION_TYPE: 'نوع الامتناع',
			NONE: 'بدون امتناع',
			ALL_BOARD_MEMBERS: 'جميع أعضاء المجلس',
			SPECIFIC_SHAREHOLDERS: 'مساهمون محددون',
			SPECIFIC_BOARD_MEMBER: 'عضو مجلس إدارة محدد',
			ADD_ACTIVE_BOARD_TO_ADD_DOCUMENT: 'يرجى تنصيب مجلس نشط لإضافة مستندات.',
			ADD_ACTIVE_BOARD_TO_ADD_MEETING: 'يرجى تنصيب مجلس نشط لعقد اجتماعات.',
			BOARD_CREATION_NOTE:
				'عزيزنا المستخدم … لا يمكن تغيير حوكمة و اعدادات المجلس عند الانتقال للخطوة التالية وفي حال رغبتك في تغيرها فضلا مسح مسودة تنصيب المجلس و البدء من جديد.',
			DISSENT: 'معترض',
			BOARD_MEMBER: 'عضو مجلس الإدارة',
			EMPLOYEE_WHO_HAS_REGISTERED: 'الموظف الذي قام بالتسجيل',
			ABSTENTION_FROM_VOTING: 'امتناع عن التصويت',
			ACCEPTED: 'وافق',
			APPLICATION: 'التطبيق',
			CONFIRM_SUBMIT_VOTE_NOTE: 'الرجاء التأكد من اختيار التصويت بشكل صحيح . حيث لا يمكنك تعديل اختيارات التصويت بعد الارسال',
			FINAL_VOTING_RESULT: 'النتيجة النهائية للتصويت',
			DECISION_FAILED: 'فشل القرار',
			RAISE: 'رفع',
			DECREASE: 'خفض',
			RAISE_CAPITAL: 'رفع رأس المال',
			AUTHORIZED_CAPITAL: 'رأس المال المصرح به',
			ISSUED_CAPITAL_IS: 'رأس المال المصدر هو',
			WHICH_IS: 'ويمثل',
			OF_AUTHORIZED_CAPITAL: 'من رأس المال المصرح به',
			INCREASE_AUTHORIZED: 'تحديث رأس المال المصرح به',
			PROFIT_CAPITALIZATION: 'رسملة الأرباح',
			PROFIT_CAPITALIZATION_DESC: 'توزيع أسهم مجانية لجميع المساهمين برسملة الأرباح المبقاة.',
			TREASURY_SHARES_ACQUISITION: 'الاستحواذ على أسهم الخزينة',
			TREASURY_SHARES_ACQUISITION_DESC: 'إنشاء أمر لشراء أسهم من جميع المساهمين الحاليين',
			PRIVATE_EQUITY_ISSUANCE: 'إصدار خاص',
			PRIVATE_EQUITY_ISSUANCE_DESC: 'إصدار أسهم جديدة لمستثمرين محددين',
			TYPE_OF_RAISE: 'نوع الزيادة',
			ELIGIBILITY_DATE: 'تاريخ الأحقية',
			MINIMUM_CAPITAL_RAISE: 'الحد الأدنى لزيادة رأس المال %',
			TOTAL_NUMBER_OF_UNIT_ISSUED: 'إجمالي عدد الأسهم المصدرة',
			TO_AVOID_FRACTIONS: 'لتجنب الكسور، قام النظام بتصحيح النسبة والوحدات تلقائيًا',
			TOTAL_CAPITAL_RAISE: 'إجمالي زيادة رأس المال',
			DISTRIBUTION_DATE: 'تاريخ التوزيع',
			RAISE_CAPITAL_NOTE:
				'سيتم توزيع الأسهم الجديدة فوراً، وسيتم تعديل سعر السهم بناءً على ذلك. ونرجو التنبيه إلى أن إصدار أي أسهم جديدة يجب أن تتم الموافقة عليه من قِبل جمعية الشركة حسب الأنظمة السعودية.',
			OTP_SEND_FAILED: 'فشل إرسال رمز التحقق المؤقت. يرجى المحاولة مرة أخرى.',
			CHECK_CAPITAL_RATIO_ERROR: 'حدث خطأ أثناء التحقق من نسبة زيادة رأس المال.',
			CANCEL_CAPITAL_RAISE: 'إلغاء رفع رأس المال',
			CAPITAL_RAISE_CANCELLED: 'تم إلغاء رفع رأس المال بنجاح',
			CONFIRM_CANCEL_CAPITAL_RAISE: 'هل أنت متأكد من رغبتك في إلغاء رفع رأس المال؟',
			PROFIT_CAPITALIZATION_CREATED_SUCCESSFULLY: 'تم تنفيذ طلب رسملة الأرباح بنجاح!',
			CAPITAL_RAISE_NOT_CANCELLED: 'لم يتم إلغاء رفع رأس المال',
			CAPITAL_RAISE: 'رفع رأس المال',
			TRANSACTION_FRACTIONS: 'كسور المعاملات',
			TRANSACTION_FRACTIONS_DESC: 'كسور الأسهم المحسوبة والمجمعة مع الملكية التفصيلية',
			FRACTION_SHARES: 'أسهم الكسور',
			OWNERS: 'المالكون',
			FRACTIONS_OWNERS: 'مالكو الكسور',
			IBAN: 'رقم الحساب المصرفي الدولي (IBAN)',
			FRACTION_TRANSFER_TITLE: 'يجب بيع الكسور وتحصيل الأموال من قبل الشركة',
			FRACTION_TRANSFER_DESC: 'يتم نقل هذه الكسور فوراً، يرجى التأكد من القيام بذلك بشكل صحيح!',
			CREATE_TRANSFER_REQUEST: 'إنشاء طلب نقل',
			FRACTION_TRANSFER: 'نقل الكسور',
			TRANSFER: 'نقل',
			PRICE_PER_SHARE: 'سعر السهم',
			COUNT_OF_SHARES: 'عدد الأسهم',
			TRANSFER_REQUEST_CREATED_SUCCESSFULLY: 'تم إنشاء طلب النقل بنجاح',
			ERROR_CREATING_TRANSFER_REQUEST: 'حدث خطأ أثناء إنشاء طلب النقل.',
			BUYER_ACCEPTANCE_STATUS: 'حالة قبول المشتري',
			CREATE_NEW_REQUEST: 'إنشاء طلب جديد',
			UPDATE_AUTHORIZED_CAPITAL: 'تحديث رأس المال المصرح به',
			CURRENT_AUTHORIZED_CAPITAL: 'رأس المال المصرح به الحالي',
			NEW_AUTHORIZED_CAPITAL: 'رأس المال المصرح به المحدث',
			ISSUED_CAPITAL: 'رأس المال المصدر',
			AUTHORIZED_CAPITAL_UPDATED_SUCCESSFULLY: 'تم تحديث رأس المال المصرح به بنجاح',
			OF_NEW_AUTHORIZED_CAPITAL: ' من رأس المال المصرح به الجديد',
			IS_BEYOND_AUTHORIZED_CAPITAL: ' يتجاوز رأس المال المصرح به',
			TIE: 'تعادل',
			BALANCE: 'الرصيد',
			NO_ACTIVE_BOARD_EXIST: 'لا يوجد مجلس إدارة نشط.',
			CAPITALS_MANAGEMENT: 'عمليات رأس المال',
			ALLOW_YOU_TO_PERFORM_RAISE_OPERATION: 'لإجراء عمليات رفع رأس المال',
			FILL_THE_FOLLOWING_TO_PROCESS_REQUEST: 'فضلاً، املأ البيانات التالية لإكمال الطلب',
			AGREEMENT_TO_TERMS_CAPITALS: 'أقر وأوافق على الشروط والأحكام الخاصة بعمليات رأس المال',
			PROFIT_CAPITALIZATION_NOTE:
				'سيتم توزيع الأسهم في تاريخ التوزيع ولا يمكن عكس العملية و سيتم تعديل المتوسطات بناءا على حجم الاصدار. هذا الاجراء يستدعي موافقة الجمعية الغير العادية حسب نظام الشركات.',
			UPDATE_AUTHORIZED_NOTE: 'سيتم تعديل رأس المال المصرح فورا. علما بان تعديله يتطلب موافقة الجمعية الغير عادية حسب أنظمة الشركات السعودي.',
			CAPITAL_RAISE_NOT_CREATED: 'طلب رفع رأس المال لم ينشأ',
			PROFIT_CAPITALIZATION_NOT_UPDATED: 'طلب رسملة الأرباح لم يتم تحديثه',
			PROFIT_CAPITALIZATION_UPDATED_SUCCESSFULLY: 'تم تحديث طلب رسملة الأرباح بنجاح',
			PROFIT_CAPITALIZATION_NOT_CREATED: 'طلب رسملة الأرباح لم ينشأ',
			DIVIDENDS_DESC: 'لإنشاء طلبات توزيع الارباح',
			DISTRIBUTION_INTERVAL: 'فترة التوزيع',
			INTERIM_DIVIDENDS: 'أرباح مرحلية',
			ANNUAL_DIVIDENDS: 'أرباح سنوية',
			REVENUE_PER_SHARE: 'الربحية لكل سهم',
			TOTAL_AMOUNT_OF_DIVIDENDS: 'إجمالي الأرباح الموزعة',
			TERMS_AND_CONDITIONS: 'الشروط والأحكام',
			AGREE_TERMS_AND_CONDITIONS: 'أوافق على الشروط والأحكام الخاصة بعملية توزيع الأرباح.',
			THREE_DAYS_PAYMENT: 'شرط الدفع قبل تاريخ التوزيع بثلاثة أيام',
			FAILURE_TO_PAY_SDAD_BILL: 'أقرّ بأن في حال عدم سداد فاتورة سداد قبل تاريخ التوزيع بثلاثة أيام سيقوم النظام بإلغاء الطلب آليّاً.',
			GENERATE_BILL: 'إنشاء فاتورة',
			DIVIDENDS_CREATED: 'تم إنشاء الأرباح بنجاح',
			CONFIRM_DIVIDEND_CREATION: 'فضلا تأكيد طلب توزيع الأرباح',
			DIVIDENDS_NOTE:
				'يرجى العلم بأن هذا الطلب، بمجرد دفعه وتوزيعه، لا يمكن إلغاؤه. في حالة الدفع والإلغاء قبل التوزيع، ستقوم منصة حفظ بخصم 1% أو 1500 ريال سعودي، أيهما أعلى، كرسوم إلغاء الخدمة.',
			PLEASE_CONFIRM_YOUR_REQUEST: 'فضلا ادخال الرمز لأتمام الطلب',
			INTERVAL: 'الفترة',
			ORDER_ID: 'رقم الطلب',
			SHAREHOLDERS_DIVIDENDS_LIST: 'قائمة أرباح المساهمين',
			DIVIDEND_CANCELLED_SUCCESS: 'تم إلغاء طلب توزيع الأرباح بنجاح',
			DIVIDEND_NOT_CANCELLED: 'لم يتم إلغاء طلب توزيع الأرباح',
			CANCEL_DIVIDEND: 'إلغاء توزيع الأرباح',
			CONFIRM_CANCEL_DIVIDEND: 'هل أنت متأكد من رغبتك في إلغاء هذا التوزيع؟',
			CONFIRM_CANCEL_PENDING_DIVIDEND: 'تأكيد إلغاء طلب توزيع الأرباح المعلق',
			CONFIRM_CANCEL_SCHEDULED_DIVIDEND: 'تأكيد إلغاء طلب توزيع الأرباح المجدول',
			SCHEDULED_DIVIDEND_CANCEL_NOTE:
				'يرجى العلم بأن حفظ ستخصم 1% أو 1500 أيهما أعلى كرسوم إدارية لإلغاء الخدمة. سيتم تحويل المبلغ المتبقي من دفعتك إلى حساب IBAN الخاص بشركتك خلال 72 ساعة عمل.',
			TOTAL_TREASURY_SHARES_TO_BE_BOUGHT: 'اجمالي عدد الأسهم المراد شرائها',
			CAN_NOT_EXCEED_FAILED: 'لا يمكن أن تتجاوز نسبة 10٪ من إجمالي حقوق الملكية. المتبقي: {{remaining}} سهم',
			CAN_NOT_EXCEED_SUCCEED: 'لا يمكن أن تتجاوز نسبة 10٪ من إجمالي حقوق الملكية',
			CURRENT_PERCENTAGE: 'الحالية: {{currentPercentage}}٪',
			REMAINING_SHARES: 'المتبقي: {{remaining}} سهم',
			DIVIDENDS_UPDATED: ' تم تحديث توزيع الأرباح بنجاح',
			DATE_MIN_3_DAYS: 'يجب أن يكون تاريخ التوزيع بعد 3 أيام على الأقل من اليوم الحالي',
			PRICE: 'سعر الشراء لكل سهم ',
			TRADING_DAYS: 'أيام التداول',
			ORDER_AMOUNT: 'اجمالي قيمة امر الشراء',
			HEFTH_COMMISSION: 'رسوم العملية',
			VAT: 'ضريبة القيمة المضافة',
			TOTAL_AMOUNT_TO_PAID: 'اجمالي رسوم العملية الواجب دفعها',
			DIVIDEND_CANCEL_NOTE:
				'عند تأكيد الإلغاء فأن النظام لن يقوم بأعادة العملية أو قيمتها وقد تحتاج الى الدفع مره أخرى في حال عدم وجود رصيد حالي وبأدخالك رمز التأكيد فأنك تقر بموافقتك على ذلك.',
			ABSTEEN_SHAREHOLDERS: 'استثناء مساهم',
			ABSTEENED_SHAREHOLDERS: 'قائمة المساهمين المستثنين من التوزيع',
			ENTER_ID_OR_NAME: 'أدخل الرقم التعريفي أو الاسم',
			SHAREHOLDER_DIRECT_IBAN_TRANSFER: 'تحويل مباشر لحساب المساهم البنكي',
			DIRECT_TRANSFER_TO_IBAN: 'قائمة المساهمين المشمولين في التحويل المباشر',
			ENTER_IBAN: 'أدخل IBAN',
			IBAN_UPDATED_SUCCESSFULLY: 'تم تحديث IBAN بنجاح',
			UPDATE_ERROR: 'حدث خطأ أثناء تحديث IBAN.',
			IBAN_VALIDATION: 'يرجى إدخال رقم IBAN صالح.',
			ENTER_IBAN_FOR_DIRECT_TRANSFER: 'أدخل جميع أرقام IBAN للتحويل المباشر',
			ABSTEEN_SHAREHOLDERS_INFO: 'التحفظ على أرباح مساهم محدد لأسباب إدارية او مالية او قضائية',
			PROFIT: 'الأرباح',
			BILL_NUMBER: 'رقم الفاتورة',
			TREASURY_SHARES_ACQUISITION_CREATED_SUCCESSFULLY: 'تم تنفيذ طلب شراء أسهم الخزينة بنجاح!',
			TREASURY_SHARES_ACQUISITION_UPDATED_SUCCESSFULLY: 'تم تحديث طلب شراء أسهم الخزينة بنجاح!',
			TREASURY_SHARES_ACQUISITION_NOT_CREATED: 'لم يتم إنشاء طلب شراء أسهم الخزينة',
			TREASURY_SHARES_ACQUISITION_NOT_UPDATED: 'لم يتم تحديث طلب شراء أسهم الخزينة',
			TOTAL_TREASURY_SHARES_TO_BE_ISSUED: 'إجمالي أسهم الخزينة التي سيتم إصدارها',
			BOUGHT: 'تم الشراء',
			REMAINING_DAYS: 'الأيام المتبقية',
			SELLERS: 'البائعون',
			OWNED_SHARES: 'الأسهم المملوكة',
			SHAREHOLDERS_LIST: 'سجل المساهمين',
			TOTAL_NEW_COMMON_SHARES: 'إجمالي الأسهم العادية المصدرة',
			ISSUING_DATE: 'تاريخ التوزيع',
			ISSUANCE_PRICE: 'قيمة السهم المصدر',
			SHARE: 'سهم',
			ADD_NEW: 'إضافة جديد',
			CLEAR_ALL_BOARD: 'مسح الكل',
			ADD_OWNERS_REGISTRY: 'إضافة سجل الملاك',
			ADD_OWNERS_REGISTRY_DESCRIPTION: 'أضف جميع بياناتك يدويًا أو قم بتحميل ملفك من جهاز الكمبيوتر الخاص بك',
			DOWNLOAD_TEMPLATE: 'تحميل النموذج',
			CLEAR_ALL: 'مسح الكل',
			CLICK_OR_DRAG: 'انقر للتحميل أو اسحب وأفلت',
			TOTAL_NO_OF_SHARES: 'إجمالي عدد الأسهم',
			SHAREHOLDER_ALREADY_ADDED: 'المساهم مضاف بالفعل',
			SHARES_EXCEEDING_LIMIT: 'الأسهم التي تتجاوز الحد: {{limit}}',
			DELETE_SHAREHOLDER_CONFIRMATION: 'تأكيد حذف المساهم',
			PRIVATE_EQUITY_ISSUANCE_UPDATED_SUCCESSFULLY: 'تم تحديث طلب إصدار الأسهم الخاصة بنجاح!',
			PRIVATE_EQUITY_ISSUANCE_CREATED_SUCCESSFULLY: 'تم تنفيذ طلب إصدار الأسهم الخاصة بنجاح!',
			PRIVATE_EQUITY_ISSUANCE_NOT_UPDATED: 'لم يتم تحديث طلب إصدار الأسهم الخاصة',
			PRIVATE_EQUITY_ISSUANCE_NOT_CREATED: 'لم يتم إنشاء طلب إصدار الأسهم الخاصة',
			PRIVATE_EQUITY_ISSUANCE_NOTE:
				' أنت تقر بأن تم اخذ الموافقة من الجمعية العامة الغير عادية و موافقة وزارة التجارة و هيئة السوق المالية وفقا للأنظمة السعودية للشركات والأوراق المالية. وتتحمل مسؤولية أي تبعات خلافا لذلك.',
			STILL_HAVE_SHARES_TO_ISSUE: 'لا يزال لديك {{remaining}} سهمًا لإصداره',
			FILE_UPLOADED: 'تم تحميل الملف بنجاح',
			NEW_CAPITAL_DOCUMENT: 'مستند رأس المال الجديد',
			CURRENTLY_UPLOADED_DOCUMENT: 'المستند المرفوع حالياً',
			'1_DAY': 'يوم',
			'3_DAYS': '3 أيام',
			'7_DAYS': '7 أيام',
			'15_DAYS': '15 يوم',
			'30_DAYS': '30 يوم',
			CREATE_INVOICE: 'انشاء فاتورة',
			AGREEMENT_TO_TERMS_TREASURY: 'أقر وأوافق على الشروط والأحكام الخاصة بعملية شراء اسهم الخزينة',
			TREASURY_SHARES_ACQUISITION_NOTE:
				'عند انتهاء امر الشراء سيتم انشاء قائمة بحقوق البائعين وتلتزم الشركة في تحويل حقوقها بشكل مباشر لحساباتهم البنكية’ وانت تقر بذلك!',
			TREASURY_CONFIRM: 'تأكيد امر شراء اسهم خزينة',
			TREASURY_CONFIRM_SUBTITLE: 'فضلا ادخال الرمز لتأكيد الامر',
			AGREEMENT_TO_TERMS_AUTHORIZED_CAPITALS: 'أقر وأوافق على الشروط والأحكام الخاصة بتحديث رأس المال المصرح به.',
			AGREEMENT_TO_TERMS_PRIVATE_EQUITY: 'أقر وأوافق على الشروط والأحكام الخاصة بعملية الإصدار الخاص.',
			CANCEL_PROFIT_CAPITALIZATION: 'الغاء رسملة الأرباح',
			CONFIRM_CANCEL_PROFIT_CAPITALIZATION: 'هل أنت متأكد من رغبتك في إلغاء عملية رسملة الأرباح؟',
			PROFIT_CAPITALIZATION_CANCELLED: 'تم إلغاء طلب رسملة الأرباح بنجاح',
			CANCEL_TREASURY_SHARES_ACQUISITION: 'إلغاء شراء أسهم الخزينة',
			CONFIRM_CANCEL_TREASURY_SHARES_ACQUISITION: 'هل أنت متأكد من رغبتك في إلغاء عملية شراء أسهم الخزينة؟',
			TREASURY_SHARES_ACQUISITION_CANCELLED: 'تم إلغاء طلب شراء اسهم خزينة بنجاح',
			CANCEL_PRIVATE_EQUITY_ISSUANCE: 'إلغاء إصدار الأسهم الخاصة',
			CONFIRM_CANCEL_PRIVATE_EQUITY_ISSUANCE: 'هل أنت متأكد من رغبتك في إلغاء عملية إصدار الأسهم الخاصة؟',
			PRIVATE_EQUITY_ISSUANCE_CANCELLED: 'تم إلغاء طلب إصدار الأسهم الخاصة بنجاح',
			OWNED_SHARES_EXCEED_LIMIT: 'الأسهم المملوكة تتجاوز الحد: {{limit}} سهم',
			SPECIFIC_BOARD_MEMBERS: 'أعضاء مجلس إدارة محددون',
			COMMITTEE_NAME: 'لجنة {{name}}',
			COMMITTEE_NAME_AR: 'اسم اللجنة بالعربية',
			COMMITTEE_NAME_EN: 'اسم اللجنة بالإنجليزية',
			COMMITTEE_DESCRIPTION: 'وصف اللجنة',
			COMMITTEE_DESCRIPTION_AR: 'وصف اللجنة بالعربية',
			COMMITTEE_DESCRIPTION_EN: 'وصف اللجنة بالإنجليزية',
			COMMITTEE_MEMBERS: 'أعضاء اللجنة',
			COMMITTEE_DETAILS: 'تفاصيل اللجنة',
			CREATE_COMMITTEE: 'إنشاء لجنة',
			NEW_COMMITTEE: 'لجنة جديدة',
			COMMITTEE_SETTINGS: 'إعدادات اللجنة',
			TOTAL_COMMITTEE_MEMBERS: 'إجمالي أعضاء اللجنة',
			COMMITTEE_TERM_YEARS: 'مدة اللجنة بالسنوات',
			MINIMUM_QUORUM_PERCENTAGE: 'نصاب الحد الأدنى للاجتماعات',
			MAXIMUM_ABSENCE_BEFORE_NOTIFICATION: 'الحد الأقصى للغياب قبل الإخطار',
			MINIMUM_NOTIFICATION_DAYS: 'الحد الأدنى لأيام الإخطار',
			ALLOW_SECRETARY_UPDATE: 'السماح بتحديث السكرتير',
			ALLOW_EXTERNAL_GUESTS: 'السماح بالضيوف الخارجيين',
			COMMITTEE_CREATED_SUCCESSFULLY: 'تم إنشاء اللجنة بنجاح',
			COMMITTEE_UPDATED_SUCCESSFULLY: 'تم تحديث اللجنة بنجاح',
			COMMITTEE_DELETED_SUCCESSFULLY: 'تم حذف اللجنة بنجاح',
			COMMITTEE_APPOINTED_SUCCESSFULLY: 'تم تعيين اللجنة بنجاح',
			COMMITTEE_TERMINATED_SUCCESSFULLY: 'تم إنهاء اللجنة بنجاح',
			APPOINT_COMMITTEE: 'تعيين اللجنة',
			TERMINATE_COMMITTEE: 'إنهاء اللجنة',
			DELETE_COMMITTEE: 'حذف اللجنة',
			CONFIRM_DELETE_COMMITTEE: 'هل أنت متأكد من حذف هذه اللجنة؟',
			CONFIRM_TERMINATE_COMMITTEE: 'هل أنت متأكد من إنهاء هذه اللجنة؟',
			CONFIRM_APPOINT_COMMITTEE: 'هل أنت متأكد من تعيين هذه اللجنة؟',
			ACTIVE_COMMITTEE: 'اللجنة النشطة',
			DRAFT_COMMITTEE: 'مسودة اللجنة',
			INACTIVE_COMMITTEE: 'اللجنة غير النشطة',
			COMMITTEE_STATUS: 'حالة اللجنة',
			SELECT_MEMBER_TYPE: 'اختر نوع العضو',
			EXTERNAL: 'خارجي',
			REGULAR: 'عادي',
			COMMITTEE_MEETINGS: 'اجتماعات اللجنة',
			MEETING_NUMBER: 'رقم الاجتماع',
			MEETING_TIME: 'وقت الاجتماع',
			MEETING_LOCATION: 'مكان الاجتماع',
			MEETING_LINK: 'رابط الاجتماع',
			ADD_GUEST: 'إضافة ضيف',
			GUEST_NAME: 'اسم الضيف',
			GUEST_ROLE: 'دور الضيف',
			COMMITTEE_DOCUMENTS: 'مستندات اللجنة',
			NEW_COMMITTEE_DOCUMENT: 'مستند لجنة جديد',
			DOCUMENT_NAME: 'اسم المستند',
			DOCUMENT_NAME_AR: 'اسم المستند بالعربية',
			DOCUMENT_NAME_EN: 'اسم المستند بالإنجليزية',
			SELECT_DOCUMENT_TYPE: 'اختر نوع المستند',
			REGULATION: 'لائحة',
			POLICY: 'سياسة',
			REPORT: 'تقرير',
			OTHER: 'أخرى',
			DOCUMENT_FILE: 'ملف المستند',
			UPLOAD_DOCUMENT: 'رفع مستند',
			UPLOADED_AT: 'تم الرفع في',
			APPOINTED_AT: 'تم التعيين في',
			TERMINATED_AT: 'تم الإنهاء في',
			MEMBERS_COUNT: 'عدد الأعضاء',
			CURRENT_MEMBERS: 'الأعضاء الحاليون',
			FILL_TO_CREATE_COMMITTEE: 'املأ هذه التفاصيل لإنشاء لجنة',
			FILL_TO_APPOINT_COMMITTEE: 'املأ هذه التفاصيل لتعيين اللجنة',
			ATTACH_MEMBERS: 'إرفاق أعضاء',
			ATTACH_MEMBERS_TO_COMMITTEE: 'إرفاق أعضاء للجنة',
			IS_SECRETARY: 'هل هو السكرتير؟',
			SELECT_MEMBERS: 'اختر الأعضاء',
			MEMBERS_ATTACHED_SUCCESSFULLY: 'تم إرفاق الأعضاء بنجاح',
			ATTENDANCE_PERCENTAGE: 'نسبة الحضور',
			COMMITTEE_ATTENDANCE: 'حضور اللجنة',
			MEETING_DECISIONS: 'قرارات الاجتماع',
			NEW_COMMITTEE_FORMATION: 'تشكيل لجنة جديدة',
			COMMITTEE_GOVERNANCE: 'حوكمة اللجنة',
			COMMITTEE_GOVERNANCE_DESC: 'يرجى اختيار حوكمة اللجنة.',
			TOTAL_COMMITTEE_MEMBERS_VALIDATION: 'يجب أن تضم اللجنة ما لا يقل عن 3 أعضاء ولا يتجاوز 15 عضواً.',
			MAXIMUM_ABSENCE_BEFORE_NOTIF_VALIDATION_COMMITTEE: 'الحد الأقصى للغياب قبل الإشعار يجب ألا يتجاوز 50% من اجتماعات اللجنة.',
			FETCH_COMMITTEE_DETAILS_ERROR: 'حدث خطأ أثناء جلب تفاصيل اللجنة.',
			DRAFT: 'مسودة',
			COMMITTEES_STRUCTURE: 'هيكل اللجان',
			COMMITTEES_MEETINGS: 'اجتماعات اللجان',
			BOARD_COMMITTEES: 'لجان مجلس الإدارة',
			FORM_NEW_COMMITTEE: 'تشكيل لجنة جديدة',
			COMMITTEES_DESC: 'املأ هذه التفاصيل لبناء شركتك',
			NO_COMMITTEE_AVAILABLE: 'لا توجد لجان متوفرة.',
			ADD_COMMITTEE_MEMBERS: 'يرجى إضافة أعضاء اللجنة',
			COMMITTEE_TERM: 'مدة اللجنة',
			COMMITTEE_MEMBER_DELETE_NOTE:
				'سيكون حذف العضو فعالاً بعد حفظ جميع التغييرات، يرجى العلم أنه بعد حفظ جميع التغييرات لن يتمكن هذا العضو من العودة إلى اللجنة إلا إذا قمت بإضافته مرة أخرى.',
			COMMITTEE_APPOINTMENT_VERIFICATION_NOTE:
				'سيكون تعيين اللجنة الجديدة فعالاً بعد التأكيد، يرجى العلم: وفقاً لأنظمة وزارة التجارة السعودية، يجب أن تتم الموافقة على تعيين لجنة الشركة الجديدة من قبل الجمعية العمومية.',
			COMMITTEE_MEMBER_CREATED_SUCCESSFULLY: 'تم إنشاء عضو اللجنة بنجاح',
			COMMITTEE_MEMBER_UPDATED_SUCCESSFULLY: 'تم تحديث عضو اللجنة بنجاح',
			'BOARD-CHAIR': 'رئيس المجلس',
			'VICE-CHAIRMAN': 'نائب الرئيس',
			'BOARD-SECRETARY': 'سكرتير المجلس',
			MEETING: 'اجتماع',
			ACTUAL_PERCENTAGE: 'النسبة المعروضة تم تقريبها لتحسين عرض الرقم , النسبة الحقيقة : {{value}}٪',
			MEETING_PUBLISHED_SUCCESSFULLY: 'تم نشر الاجتماع بنجاح',
			EXPLANATION: 'ايضاحات',
			LOYALTY_PROGRAMS: 'برنامج الولاء',
			LOYALTY_PROGRAMS_DESC: 'احتفظ بموظفيك الموهوبين',
			LOYALTY_PROGRAMS_CREATE_DESC: 'فضلا تعبئة الطلب وأرساله للنظام',
			UNLOCK_NOW: 'افتح الآن',
			FEATURE_LOCKED: 'الميزة مقفلة',
			FEATURE_LOCKED_DESC1: 'عقد شركتك لا يدعم هذه الميزة.',
			FEATURE_LOCKED_DESC2: 'يرجى تضمين هذا في عقدك وطلب فتح الميزة.',
			EMPLOYEE_NAME: 'اسم المستفيد',
			INCENTIVE_TYPE: 'نوع الحافز',
			FREE_TREASURY_SHARES: 'أسهم الخزينة المتوفرة: {{num}}',
			AVAILABLE_TREASURY_SHARES: 'أسهم الخزينة المتوفرة: {{num}}',
			SUSPENDED_TREASURY_SHARES: 'أسهم الخزينة المعلقة: {{num}}',
			NO_SHARES_AVAILABLE: 'لا توجد أسهم خزينة متوفرة لإنشاء برنامج ولاء',
			LOYALTY_PROGRAM_CREATED: 'تم إنشاء برنامج الولاء {{type}} بنجاح!',
			GRANT: 'منح',
			GRANT_DESC: 'منح أسهم دون مقابل.',
			OPTION: 'خيار',
			OPTION_DESC: 'منح أسهم الخزينة لفريقك بسعر مخفض أو محدد.',
			BENEFICIARY_NATIONAL_ID: 'الرقم الوطني للمستفيد',
			FULL_NAME: 'الاسم الكامل',
			NUMBER_OF_SHARES: 'عدد الأسهم',
			SALARY_DEDUCTION_PAYMENT: 'الخصم من الراتب',
			SALARY_DEDUCTION_PAYMENT_INFO: 'في حال عدم تفعيلها فأن المستفيد يقوم بالدفع من خلال تطبيق تناقل',
			COMPANY_DEDUCTION: 'ستقوم الشركة بخصم المبلغ.',
			RESTRICTED_BY_DATE: 'مقيد بالتاريخ',
			RESTRICTED_BY_DATE_DESC: 'سيتم إضافة الأسهم في محفظة المستفيد في هذا التاريخ.',
			PERIODIC: 'دوري',
			PERIODIC_DESC: 'سيتم منح الأسهم بناءً على جدول زمني محدد إلى تاريخ معين.',
			LOYALTY_ACKNOWLEDGE1: 'أقر وأوافق على الشروط والأحكام الخاصة بعملية برنامج الولاء.',
			LOYALTY_ACKNOWLEDGE2: 'بالنقر، أقر بأن هذه العملية لا يمكن التراجع عنها.',
			LOYALTY_ACKNOWLEDGE3: 'بالنقر أقر بأن إدارة الشركة التنفيذية تمتلك الصلاحية لهذا اﻻجراء',
			CURRENT_EMPLOYMENT_CONDITION: 'شرط استمرار العمل',
			CURRENT_EMPLOYMENT_CONDITION_DESC: 'يوافق الموظف على اﻻستمرار في العمل لدى الشركة طوال فترة البرنامج',
			START_DATE: 'تاريخ البدء',
			INTERVAL_PERIOD: 'الفترة الزمنية',
			INTERVAL_AMOUNT: 'عدد الفترات',
			SHARE_PER_INTERVAL: 'الأسهم / الفترة',
			NUMBER_OF_INTERVALS: 'عدد الفترات',
			PLANNED: 'مخطط',
			PROGRAM_TOTAL_SHARES: 'إجمالي أسهم البرنامج',
			PROGRAM_TOTAL_VALUE: 'القيمة الإجمالية للبرنامج',
			CONFIRM_GRANT: 'تأكيد المنح',
			CONFIRM_GRANT_DESC:
				'يرجى ملاحظة أن بعض البرامج فقط قابلة للعكس. عند قبول المستفيد وإتمام أي تحويلات، لن يكون مبلغ تلك الأسهم قابلاً للاسترداد تحت أي ظرف من الظروف.',
			COMMITTEES_DOCUMENTS: 'مستندات اللجان',
			SELECT_COMMITTEE: 'اختر لجنة لجدولة اجتماع لها',
			NEW_COMMITTEE_MEETING: 'اجتماع لجنة جديد',
			NEW_NAME_COMMITTEE_MEETING: 'اجتماع لجنة {{name}} جديد',
			CHOOSE_MEETING_TIME: 'اختر وقت الاجتماع',
			TERMINATE: 'إنهاء',
			EXTEND: 'تمديد',
			TERMINATE_CONFIRMATION: 'تأكيد الإنهاء',
			EXTEND_COMMITTEE: 'تمديد اللجنة',
			ADDITIONAL_YEARS: 'السنوات الإضافية',
			MEETING_DURATION: 'مدة الاجتماع',
			PROGRAM_TYPE: 'نوع البرنامج',
			GRANT_SHARES: 'منح الأسهم',
			OPTION_SHARES: 'خيارات الأسهم',
			LOYALTY_PROGRAM_PERIODIC: 'مرحلي',
			PERIODIC_GRANT_SHARES: 'منح أسهم مرحلي',
			PERIODIC_OPTION_SHARES: 'خيارات أسهم مرحلية',
			PROGRESS: 'التقدم',
			BENEFICIARY_NAME: 'اسم المستفيد',
			PAYMENT_METHOD: 'طريقة الدفع',
			PAYMENT: 'الدفع',
			EMPLOYEE_PAYS_THROUGH_APP: 'الموظف يدفع عبر التطبيق',
			EMPLOYEE_PAYS_THROUGH_APP_DESC: 'سيستخدم حساب الاستثمار أو البطاقة للدفع',
			SALARY_DEDUCTION: 'خصم من الراتب',
			SALARY_DEDUCTION_DESC: 'الشركة مسؤولة عن تحصيل الدفعة',
			PROGRAM_SHARES: 'أسهم البرنامج',
			SHARES_GRANTED: 'الأسهم الممنوحة',
			SHARES_NOT_GRANTED: 'الأسهم غير الممنوحة',
			TOTAL_PAYMENT: 'إجمالي الدفع',
			ORDER: 'الترتيب',
			GRANT_DATE: 'تاريخ المنح',
			GRANTED: 'تم المنح',
			NOT_GRANTED: 'لم يتم المنح',
			PENDING_PAYMENT: 'بانتظار الدفع',
			DOWNLOAD_FILE: 'تحميل الملف',
			NUM_SHARES: '{{num}} سهم',
			CANCEL_DISTRIBUTION_CONFIRM: 'هل أنت متأكد من إلغاء هذا التوزيع؟',
			DISTRIBUTE_CONFIRM: 'هل أنت متأكد من منح هذا التوزيع؟',
			CONFIRM_GRANT_CANCELLATION: 'تأكيد إلغاء المنح',
			CONFIRM_GRANT_CANCELLATION_DESC:
				'يرجى العلم أن هذا المنح يخضع لعقد بين شركتك والمستفيد وإلغاءه بدون سبب قانوني يمكن أن يؤدي إلى تبعات قانونية، لذا يرجى استخدام هذا الإجراء بحكمة.',
			CONFIRM_OPTION_GRANT: 'تأكيد منح الخيار',
			CONFIRM_OPTION_REFUSAL: 'تأكيد رفض الخيار',
			CONFIRM_OPTION_GRANT_APP_DESC:
				'يرجى العلم أن هذا المنح يخضع لعقد بين شركتك والمستفيد وأنت تؤكد تفويض تخاروج للتمويل بتحصيل المبلغ من الموظف، وإدخال الرمز يعني أن المنح نهائي وغير قابل للإلغاء.',
			CONFIRM_OPTION_GRANT_SALARY_DESC:
				'يرجى العلم أن هذا المنح يخضع لعقد بين شركتك والمستفيد وأنت تؤكد أنه تم خصم المبلغ من راتب الموظف، وإدخال الرمز يعني أن المنح نهائي وغير قابل للإلغاء.',
			BENEFICIARIES: 'المستفيدون',
			TRANSFER_TYPE: 'نوع النقل',
			SELECT_COMMITTEE_DOCUMENT: 'اختر لجنة لإضافة مستند لها',
			MEMBER_PHONE_NUMBER: 'رقم جوال العضو',
			ACCEPTANCE_DAYS: 'أيام القبول',
			ELIGIBILITY_DATE_MIN: 'تاريخ الأهلية يجب أن يكون على الأقل {{days}} يومًا من اليوم',
			ONE_MONTH: 'شهر',
			THREE_MONTHS: '3 أشهر',
			SIX_MONTHS: '6 أشهر',
			NINE_MONTHS: '9 أشهر',
			TWELVE_MONTHS: '12 شهر',
			MEMBER_ALERT: 'تكون بعض المعلومات غير دقيقة لحين تسجيل العضو عن طريق نفاذ , فضلا التأكد من رقم الهوية',
			GRANTED_SHARES: 'الأسهم الممنوحة',
			LOYALITY_START_DATE: 'تاريخ بدء البرنامج',
			'14_DAYS': '14 يوم',
			'21_DAYS': '21 يوم',
			OPTION_VIEW: 'عرض الخيار',
			GENERAL_SUSPEND_LOYALITY_MESSAGE: 'يوجد تعليق عام فعال، لا يُسمح بإنشاء برامج الولاء',
			DISTRIBUTED_TOTAL_NOT_EQUAL_NUMBER_OF_SHARES: 'إجمالي الأسهم الموزعة لا يساوي إجمالي عدد الأسهم',
			PAID_AMOUNT: 'المبلغ المدفوع',
			REMAINING_AMOUNT: 'المبلغ المتبقي',
			LOYALTY_PROGRAM_ACTIVATION_NOTE:
				'فضلا التأكد من وجود برنامج منح الخزينة والولاء في النظام الأساس للشركة حيث ان النظام يلزم الشركات اخذ موافقة الجمعية العمومية لإنشاء البرنامج.',
			COMMITTEE_MEMBER_DELETED_SUCCESSFULLY: 'تم حذف عضو اللجنة بنجاح',
			COMMITTEE_CHAIRMAN: 'رئيس اللجنة',
			COMMITTEE_VICE_CHAIRMAN: 'نائب رئيس اللجنة',
			FAILED: 'فشل',
			SEARCH_IN_ATTENDANCE: 'البحث في الحضور',
			SUSPEND_REASON_TOOLTIP: 'سبب التعليق الذي يظهر للمساهمين',
			UPLOAD_DOCUMENTS_TOOLTIP: 'المستندات التي تظهر للمساهمين',
		},
		COMPANY_INFORMATION: {
			OVERVIEW: 'نظرة عامة',
			SHAREHOLDERS_LIST: 'سجل المساهمين',
			MAJOR_SHAREHOLDERS: 'كبار الملاك',
			TRANSACTIONS_LOGS: 'سجل التناقل',
			PAYMENTS: 'الفوترة',
			DATA_ROOM: 'غرفة البيانات',
			FINANCIAL_STATEMENT: 'القوائم المالية',
			TOTAL_COMMON_SHARES: 'الأسهم العادية',
			COMPANY_CAPITAL_IN_SAR: 'رأس مال الشركة',
			LATEST_TRANSACTIONS: 'أحدث العمليات على حساب الشركة',
			REGISTRY_TRANSACTIONS: 'قيد حركة سهم',
			COUNT_OF_FREE_COMMON_SHARES: 'الأسهم العادية الحرة',
			COUNT_OF_FREE_PREFERRED_SHARES: 'الأسهم الممتازة الحرة',
			GRANTED_REQUESTS: 'طلبات المنح القائمة',
			COUNT_OF_SUSPENDED_COMMON_SHARES: 'الأسهم العادية المعلقة',
			COUNT_OF_SUSPENDED_PREFERRED_SHARES: 'الأسهم الممتازة المعلقة',
			GRANTED_TREASURY_SHARES: 'أسهم الخزينة الممنوحة',
			COUNT_OF_MORTGAGED_COMMON_SHARES: 'الأسهم العادية المرهونة',
			COUNT_OF_MORTGAGED_PREFERRED_SHARES: 'الأسهم الممتازة المرهونة',
			RESERVED_TREASURY_SHARES: 'أسهم الخزينة المحجوزة',
			VAT_REGISTRATION_NUMBER: 'رقم التسجيل في ضريبة القيمة المضافة',
			PAYMENT_TYPE: 'نوع الدفع',
			PLAN: 'الباقة',
			INVOICE_NUMBER: 'رقم الفاتورة',
			WALLET_CHARGE: 'شحن المحفظة',
			POINT_WALLET_CHARGE: 'شحن محفظة النقاط',
			BUY_PLAN: 'شراء باقة',
			CAP_TABLE: 'جدول الملكية',
			NAME_OF_SHAREHOLDER: 'اسم المساهم',
			TOTAL_VALUE_OF_HOLDINGS: 'إجمالي قيمة المساهمة',
			EQUITY: 'حقوق الملكية',
			TOTAL_SHARES_HOLDINGS: 'إجمالي عدد الأسهم',
			PERCENTAGE_OF_HOLDINGS: 'نسبة المساهمة',
			OTHERS: 'باقي المسامهين',
			NO_PREFERRED_SHARES: 'لا يوجد أسهم ممتازة',
			DOCUMENTS: 'المستندات',
			BRAND_IDENTITY: 'الهوية التجارية',
			UPDATE_BRAND_IDENTITY: 'تحديث الهوية البصرية',
			COMPANY_AR_NAME: 'اسم الشركة باللغة العربية',
			COMPANY_EN_NAME: 'اسم الشركة باللغة الإنجليزية',
			DESCRIPTION_IN_ARABIC: 'الوصف باللغة العربية',
			DESCRIPTION_IN_ENGLISH: 'الوصف باللغة الإنجليزية',
			COMPANY_LOGO: 'شعار الشركة',
			SEND_REQUEST_FOR_APPROVAL: 'إرسال طلب للموافقة',
			UNDER_REVIEW: 'تحت المراجعة',
			UNDER_REVIEW_DESC: 'تم طلب تحديث الهوية التجارية بنجاح، طلبكم قيد المراجعة',
			SUBMIT_IDENTITY_SUCCESS: 'تم إرسال الهوية البصرية للمراجعة بنجاح',
			NO_PREFERRED_SHARES_AVAILABLE: 'لا توجد أسهم ممتازة مسجلة',
			COMPANY_MANAGER_AR_NAME: 'اسم مدير الشركة باللغة العربية',
			COMPANY_MANAGER_EN_NAME: 'اسم مدير الشركة باللغة الإنجليزية',
			MAJOR_SHAREHOLDERS_DESC: 'من يملكون 5% واكثر من أسهم الشركة',
			COUNT: 'العدد',
			INSUFFICIENT_BALANCE: 'الرصيد غير كافٍ',
			SETTINGS: 'الإعدادات',
			TRANSFER_SETTINGS: 'إعدادات النقل',
			CUSTOMIZE_TRANSFER_RULES: 'تخصيص قواعد النقل',
			TRANSFER_LIMITATION: 'قيود النقل',
			MINIMUM_SHARES_PER_TRANSFER: 'الحد الأدنى للأسهم للنقل',
			MAXIMUM_SHARES_PER_TRANSFER: 'الحد الأقصى للأسهم للنقل',
			MINIMUM_TRANSFER_SELLING_PRICE: 'الحد الأدنى لسعر البيع للنقل',
			TRANSFER_ACTIVATIONS: 'تفعيل النقل',
			HALT_TRANSFER: 'إيقاف النقل',
			COMPANY_APPROVAL_ON_TRANSFER_REQUESTS: 'موافقة الشركة على طلبات النقل',
			VIEW_LAST_PRICE_CHART: 'عرض مخطط السعر الأخير',
			PER_SHARE: 'لكل سهم',
			TRANSFER_SETTINGS_UPDATED_SUCCESSFULLY: 'تم تحديث إعدادات النقل بنجاح',
			MINIMUM_SHARES_PER_TRANSFER_MIN: 'يجب أن يكون الحد الأدنى للأسهم للنقل على الأقل 1',
			MAXIMUM_SHARES_PER_TRANSFER_MIN: 'يجب أن يكون الحد الأقصى للأسهم للنقل على الأقل 1',
			MINIMUM_TRANSFER_SELLING_PRICE_MIN: 'يجب أن يكون الحد الأدنى لسعر البيع للنقل على الأقل 0.01',
			APPROVALS: 'الموافقات',
			LIMITATION_TRANSFER_SETTINGS_UPDATED_SUCCESSFULLY: 'تم تحديث إعدادات قيود النقل بنجاح',
			ACTIVATION_TRANSFER_SETTINGS_UPDATED_SUCCESSFULLY: 'تم تحديث إعدادات تفعيل النقل بنجاح',
			EMPTY_INFORMATION_TOOLTIP: 'اترك هذا الحقل فارغًا إذا لم يكن هناك قيود يجب تطبيقها',
			SETTINGS_CONFIRM_TITLE: 'تحديث إعدادات النقل',
			TRANSFER_RESTRICTION_NOTE:
				'ملاحظة مهمة : إضافه قيود على تداول الأسهم يجب ان يكون بموافقة الجميعة العامة و مدرج في النظام الأساس للشركة و عكس ذلك يعتبر مخالفة صريحة لنظام الشركات السعودي وانظمة هيئة السوق المالية.',
			HALT_TRANSFER_NOTE: 'ملاحظة مهمة: ايقاف النقل لا يلغي العمليات القائمة, الغاء العمليات القائمة يتم حصرا بتعليق أسهم الشركة.',
			TOTAL_AMOUNT: 'إجمالي المبلغ',
			TRANSFER_APPROVALS: 'موافقات النقل',
			APPROVE: 'موافقة',
			APPROVE_CONFIRMATION: 'هل أنت متأكد من الموافقة على طلب النقل هذا؟',
			REJECT: 'رفض',
			REJECT_CONFIRMATION: 'هل أنت متأكد من رفض طلب النقل هذا؟',
			TRANSFER_APPROVED_SUCCESSFULLY: 'تمت الموافقة على طلب النقل بنجاح',
			TRANSFER_REJECTED_SUCCESSFULLY: 'تم رفض طلب النقل بنجاح',
			REJECTION_NOTE: 'سبب الرفض',
			VIEW_REJECTION_NOTE: 'عرض سبب الرفض',
			COMPANY_APPROVAL_STATUS: 'حالة موافقة الشركة',
			CONTACT_PHONE_NUMBER: 'رقم جوال للتواصل',
			CONTACT_EMAIL: 'البريد الإلكتروني للتواصل',
			GENERAL_SUSPEND_MESSAGE: 'يوجد تعليق عام فعال لا يمكن تعديل الاعدادات',
		},
		USERS_MANAGEMENT: {
			ADD_NEW_USER: 'إضافة مستخدم جديد',
			UPDATE_USER: 'تحديث المستخدم',
			TO_MANAGE_YOUR_SYSTEM: 'لإدارة مستخدمي النظام الخاص بك',
			ADD_USER: 'إضافة مستخدم',
			USER_NAME: 'اسم المستخدم',
			ACCESS_ROLE: 'الصلاحيات',
			FILL_DETAILS_TO_ADD_USER: 'فضلا اكمال البيانات لاضافة المستخدم ',
			SELECT_ACCESS_AUTHORITY: 'حدد صلاحيات الوصول',
			VIEW_COMPANY_INFORMATION: 'عرض معلومات الشركة',
			COMPANY_DOCUMENT_UPDATE: 'تحديث مستندات الشركة',
			USERS_MANAGEMENT: 'إدارة المستخدمين',
			REGISTRY_TRANSACTIONS: 'قيد حركه اسهم',
			HEIR_TRANSACTION: 'قيد حركه ورثه',
			SHAREHOLDER_INFORMATION: 'عرض معلومات المساهم',
			NOTICE: 'تبليغ',
			SUSPEND_ACTION: 'التعليق',
			CHARGE_POINTS: 'شحن النقاط',
			ANNOUNCEMENT_ACTION: 'إجراء الإعلان',
			CUSTOMER_SERVICE: 'خدمة العملاء',
			UPDATE_COMPANY_INFORMATION: 'تحديث معلومات الشركة',
			FINANCIAL_STATEMENT: 'القوائم المالية',
			EDIT_USER: 'تعديل المستخدم',
			SUSPEND: 'تعليق',
			SUSPEND_USER: 'تعليق المستخدم',
			SUSPEND_USER_DESC: 'هل أنت متأكد أنك تريد تعليق هذا المستخدم؟',
			UNSUSPEND_USER: 'إلغاء تعليق المستخدم',
			DELETE_USER: 'حذف المستخدم',
			DELETE_USER_DESC: 'هل أنت متأكد أنك تريد حذف هذا المستخدم؟',
			RESET_PASSWORD: 'إعادة تعيين كلمة المرور',
			RESET_USER_PASSWORD: 'إعادة تعيين كلمة مرور للمستخدم',
			COMPANY: 'الشركة',
			COMPANY_INFORMATION: 'معلومات الشركة',
			MORTGAGE_REQUEST: 'طلب الرهن العقاري',
			MORTGAGE_RELEASE: 'إصدار الرهن العقاري',
			SYSTEM_USERS: 'مستخدمو النظام',
			SELECT_AR_LEAST_ONE: 'الرجاء تحديد الصلاحية واحدة على الأقل',
			USER_CREATED_SUCCESSFULLY: 'تم إنشاء المستخدم بنجاح',
			USER_UPDATED_SUCCESSFULLY: 'تم تحديث بيانات المستخدم بنجاح',
			USER_NOT_FOUND: 'المستخدم غير موجود',
			USER_SUSPENDED: 'تم تعليق المستخدم بنجاح',
			USER_UNSUSPENDED: 'تم إلغاء تعليق المستخدم بنجاح',
			UNSUSPEND: 'إلغاء تعليق',
			USER_DELETED: 'تم حذف المستخدم بنجاح',
			USER_PASSWORD_RESET: 'تم إعادة تعيين كلمة مرور المستخدم بنجاح',
		},
		MORTGAGE: {
			CREATE_NEW_REQUEST: 'إنشاء طلب جديد',
			FILL_DATA: 'املأ هذه التفاصيل لخدمة عميلك.',
			COMMERCIAL_REGISTRATION_NUMBER: 'رقم السجل التجاري',
			iNVESTOR_NOT_FOUND: 'لم يتم العثور على المستثمر',
			REGISTER_NUMBER_NOT_FOUND: 'لم يتم العثور على رقم السجل',
			BOARD: 'مجلس الإدارة',
			MEMBER: 'عضو',
			NATIONALITY: 'الجنسية',
			COMPANY_DOCUMENTS: 'مستندات الشركة',
			TOTAL_SHARES_HOLD: 'إجمالي الأسهم المحتفظ بها',
			ON: 'على',
			HOLD_TO: 'الاحتفاظ بـ',
			HOLD_SHARES: 'الاحتفاظ بالأسهم',
			TOTAL_SHARES_NUM: 'إجمالي عدد الأسهم',
			MATURITY_DATE: 'تاريخ الاستحقاق',
			MORTGAGE_MATURITY_DATE: 'تاريخ استحقاق الرهن',
			AGREEMENT_1: 'أقر وأوافق على الشروط والأحكام الخاصة بمعاملة السجل.',
			AGREEMENT_2: 'بالنقر أقر بأن هذه المعاملة لا يمكن عكسها.',
			REQUEST_NUMBER: 'رقم الطلب',
			REQUEST_DATE: 'تاريخ الطلب',
			CLIENT_ID: 'رقم العميل',
			HISTORY: 'التاريخ',
			REQUEST: 'الطلب',
			RELEASE_MORTGAGE: 'إصدار الرهن العقاري',
			ACTIVITY_LOG: 'سجل النشاط',
		},
	},
};

export default ar;
